(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["circular-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const MOBILE_BREAKPOINT = 768;
  const DEFAULT_GAP_PX = 22;
  
  const carousels = document.querySelectorAll('.circular-carousel');
  
  const getCenterOffset = (containerWidth, itemWidth) => 
    (containerWidth / 2) - (itemWidth / 2);
  
  const getViewportCenter = (scrollLeft, containerWidth) =>
    scrollLeft + (containerWidth / 2);
  
  const getMobileCarouselPosition = (currentIndex, totalItems, itemWidth, centerOffset, leftAligned = false) => {
    const basePosition = (totalItems * itemWidth) + (currentIndex * itemWidth);
    return leftAligned ? basePosition : basePosition - centerOffset;
  };
  
  const getIsMobile = () => !window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`).matches;

  const createResizeObserver = (carousel, handleResize) => {
    let resizeTimeout = null;
    
    const resizeObserver = new ResizeObserver((entries) => {
      carousel._isResizing = true;
      
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        try {
          handleResize();
        } catch (error) {
          console.error('Error in handleResize:', error);
        } finally {
          carousel._isResizing = false;
        }
      }, 150);
    });
    
    return resizeObserver;
  };
  
  const createDot = (index) => {
    const dot = document.createElement('button');
    dot.className = 'circular-carousel-dot';
    dot.setAttribute('data-index', index);
    dot.setAttribute('aria-label', `Go to item ${index + 1}`);
    return dot;
  };

  const hasDuplicates = (scrollContainer) => 
    scrollContainer.querySelectorAll('.circular-carousel-item.duplicate').length > 0;
  
  // Calculates boundaries of original items in the duplicated carousel
  const getOriginalItemBounds = (totalItems, itemWidth) => ({
    start: totalItems * itemWidth,
    end: totalItems * 2 * itemWidth
  });
  
  // Normalize a scroll position into the range of the original items
  const normalizeScrollPosition = (position, startOfOriginals, endOfOriginals) => {
    if (position >= startOfOriginals && position <= endOfOriginals) {
      return position - startOfOriginals;
    } else if (position >= endOfOriginals) {
      return position - endOfOriginals;
    } else {
      // In beginning duplicates
      return position;
    }
  };
  
  const calculateMobileCarouselIndex = (viewportCenter, totalItems, itemWidth) => {
    const { start: startOfOriginals, end: endOfOriginals } = getOriginalItemBounds(totalItems, itemWidth);
    const adjustedViewportCenter = normalizeScrollPosition(viewportCenter, startOfOriginals, endOfOriginals);
    const itemCenterOffset = itemWidth / 2;
    const calculatedIndex = Math.round((adjustedViewportCenter - itemCenterOffset) / itemWidth);
    return Math.max(0, Math.min(calculatedIndex, totalItems - 1));
  };
  
  const calculateLeftAlignedIndex = (scrollLeft, totalItems, itemWidth) => {
    const { start: startOfOriginals, end: endOfOriginals } = getOriginalItemBounds(totalItems, itemWidth);
    const adjustedScrollLeft = normalizeScrollPosition(scrollLeft, startOfOriginals, endOfOriginals);
    const calculatedIndex = Math.floor(adjustedScrollLeft / itemWidth);
    return Math.max(0, Math.min(calculatedIndex, totalItems - 1));
  };
  
  const setScrollPosition = (scrollContainer, index, totalItems, itemWidth, gapPx, smooth = false, leftAligned = false) => {
    const containerWidth = scrollContainer.clientWidth;
    const { start: startOfOriginals } = getOriginalItemBounds(totalItems, itemWidth);
    
    let targetScrollLeft;
    if (leftAligned) {
      // For left-aligned (on desktop), position first item at the left edge of the container
      targetScrollLeft = startOfOriginals + (index * itemWidth);
    } else {
      const centerOffset = getCenterOffset(containerWidth, itemWidth);
      targetScrollLeft = getMobileCarouselPosition(index, totalItems, itemWidth, centerOffset, false);
    }
    
    if (smooth) {
      scrollContainer.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    } else {
      scrollContainer.scrollLeft = targetScrollLeft;
    }
  };
  
  const initializeItemWidth = (originalItems, gapPx) => {
    if (originalItems[0]) {
      return originalItems[0].offsetWidth + gapPx;
    }
    return 0;
  };
  
  const isCarouselNeeded = (scrollContainer, totalItems, itemWidth) => {
    const containerWidth = scrollContainer.clientWidth;
    const totalItemsWidth = totalItems * itemWidth;
    return totalItemsWidth > containerWidth;
  };
  
  const isDesktopEnabled = (carousel) => {
    return carousel.hasAttribute('data-enable-desktop');
  };
  
  const generateDots = (positionIndicator, totalItems, itemsPerPage = 1) => {
    if (!positionIndicator) {
      return;
    }
    
    // Use DocumentFragment for better performance, hopefully
    const fragment = document.createDocumentFragment();
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    
    for (let i = 0; i < totalPages; i++) {
      const dot = createDot(i);
      fragment.appendChild(dot);
    }
    
    positionIndicator.innerHTML = '';
    positionIndicator.appendChild(fragment);
  };
  
  const updateActiveDot = (positionIndicator, scrollLeft, totalItems, itemWidth, leftAligned = false, containerWidth = 0, calculatedIndex = null) => {
    if (!positionIndicator) return;
    const dots = positionIndicator.querySelectorAll('.circular-carousel-dot');

    let activeDotIndex;
    if (calculatedIndex !== null) {
      activeDotIndex = calculatedIndex;
    } else {
      if (leftAligned) {
        activeDotIndex = calculateLeftAlignedIndex(scrollLeft, totalItems, itemWidth);
      } else {
        const viewportCenter = getViewportCenter(scrollLeft, containerWidth);
        activeDotIndex = calculateMobileCarouselIndex(viewportCenter, totalItems, itemWidth);
      }
    }
    
    // Normalise to be between 0 and totalItems-1
    activeDotIndex = ((activeDotIndex % totalItems) + totalItems) % totalItems;
    
    // Check if the correct dot is already active - skip update if so
    // Only check within this carousel's positionIndicator
    const currentActiveDot = positionIndicator.querySelector('.circular-carousel-dot.dot-active');
    if (currentActiveDot) {
      const currentActiveIndex = parseInt(currentActiveDot.getAttribute('data-index'), 10);
      if (currentActiveIndex === activeDotIndex) {
        return; // Already showing the correct dot
      }
    }
    dots.forEach((dot, index) => {
      if (index === activeDotIndex) {
        dot.classList.remove('dot-inactive');
        dot.classList.add('dot-active');
      } else {
        dot.classList.remove('dot-active');
        dot.classList.add('dot-inactive');
      }
    });
  };

  const updateIndicatorFromScroll = (scrollContainer, positionIndicator, totalItems, itemWidth, currentIndex, leftAligned = false, isMobile = true) => {
    const containerWidth = scrollContainer.clientWidth;
    const scrollLeft = scrollContainer.scrollLeft;
    
    let newIndex;
    if (leftAligned) {
      newIndex = calculateLeftAlignedIndex(scrollLeft, totalItems, itemWidth);
    } else {
      const viewportCenter = getViewportCenter(scrollLeft, containerWidth);
      newIndex = calculateMobileCarouselIndex(viewportCenter, totalItems, itemWidth);
    }

    // Only update dots on mobile
    if (isMobile && positionIndicator) {
      updateActiveDot(positionIndicator, scrollLeft, totalItems, itemWidth, leftAligned, containerWidth, newIndex);
    }

    return newIndex;
  };
  
  const createPositionIndicator = (carousel, scrollContainer) => {
    const existingIndicator = carousel.querySelector('.circular-carousel-position-indicator');
    if (existingIndicator) {
      return existingIndicator;
    }
    
    const positionIndicator = document.createElement('div');
    positionIndicator.className = 'circular-carousel-position-indicator';

    const wrapper = document.createElement('div');
    wrapper.className = 'w-full flex justify-center';
    wrapper.appendChild(positionIndicator);

    scrollContainer.parentNode.insertBefore(wrapper, scrollContainer.nextSibling);
    
    // Add padding-bottom to carousel container to reserve space for indicator (mobile only)
    carousel.style.paddingBottom = '10px';
    
    return positionIndicator;
  };

  const applySnapClasses = (items, leftAligned) => {
    items.forEach(item => {
      if (leftAligned) {
        item.classList.remove('snap-center');
        item.classList.add('snap-start');
      } else {
        item.classList.remove('snap-start');
        item.classList.add('snap-center');
      }
    });
  };
  
    const createDuplicates = (scrollContainer, originalItems, carousel, isMobile = true, desktopEnabled = false) => {
    const existingDuplicates = scrollContainer.querySelectorAll('.circular-carousel-item.duplicate');
    existingDuplicates.forEach(dup => dup.remove());

    // Left-aligned mode is automatically enabled on desktop. We use centered on mobile
    const leftAligned = desktopEnabled && !isMobile;
    const createStyledClone = (item) => {
      const clone = item.cloneNode(true);
      clone.classList.add('duplicate');

      if (!desktopEnabled) {
        clone.classList.add('md:hidden');
      }
      clone.ariaHidden = 'true';
      // Duplicates stay clickable but must not be focusable inside aria-hidden
      clone.querySelectorAll('a[href], area[href], button, input, select, textarea, iframe, object, embed, audio[controls], video[controls], [contenteditable], [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      return clone;
    };

    const beginningFragment = document.createDocumentFragment();
    const endFragment = document.createDocumentFragment();
    
    originalItems.forEach(item => {
      const clone = createStyledClone(item);
      beginningFragment.appendChild(clone);
      endFragment.appendChild(clone.cloneNode(true));
    });
    
    scrollContainer.insertBefore(beginningFragment, originalItems[0]);
    scrollContainer.appendChild(endFragment);

    const duplicateItems = scrollContainer.querySelectorAll('.circular-carousel-item.duplicate');
    applySnapClasses(duplicateItems, leftAligned);
  };
  
  const cleanupCarousel = (positionIndicator, scrollContainer, carousel) => {
    if (positionIndicator) {
      positionIndicator.parentNode.remove();
    }
    // Reset padding-bottom if it was set
    if (carousel) {
      carousel.style.paddingBottom = '';
    }
    const existingDuplicates = scrollContainer.querySelectorAll('.circular-carousel-item.duplicate');
    existingDuplicates.forEach(dup => dup.remove());
    return null; // Return null to reset the positionIndicator reference
  };
  
  const initCarousel = (carousel) => {
    const scrollContainer = carousel.querySelector('.circular-carousel-container');
    const originalItems = carousel.querySelectorAll('.circular-carousel-item:not(.duplicate)');
    
    if (!scrollContainer || !originalItems.length) return;

    let positionIndicator = null;
    
    const gapPx = parseInt(carousel.dataset.gapPx) || DEFAULT_GAP_PX;

    let isMobile = getIsMobile();
    let desktopEnabled = isDesktopEnabled(carousel);
    
    const getLeftAligned = (desktopEnabled, isMobile) => desktopEnabled && !isMobile;
    let leftAligned = getLeftAligned(desktopEnabled, isMobile);

    applySnapClasses(originalItems, leftAligned);
    const totalItems = originalItems.length;
    let currentIndex = 0;
    let isTransitioning = false;
    let itemWidth = 0;
    let itemsPerPage = 1;
  
    const calculateItemsPerPage = () => {
      if (!itemWidth || itemWidth === 0) return 1;
      const containerWidth = scrollContainer.clientWidth;
      return Math.max(1, Math.floor(containerWidth / itemWidth));
    };

    const generateDotsWithIndicator = () => {
      // Only create dots on mobile - desktop uses arrow navigation only
      if (isMobile) {
        if (!positionIndicator) {
          positionIndicator = createPositionIndicator(carousel, scrollContainer);
        }
        generateDots(positionIndicator, totalItems, 1); // Mobile always uses item-by-item navigation
      } else {
        if (positionIndicator) {
          positionIndicator = cleanupCarousel(positionIndicator, scrollContainer, carousel);
        }
      }
    };

    let arrowClickHandlers = null;

    const addEventListeners = () => {
      scrollContainer.addEventListener('scroll', handleScroll);
      // Only add dot click handler on mobile
      if (positionIndicator && isMobile) {
        positionIndicator.addEventListener('click', handleDotClick);
      }
      
      const { prev: prevBtn, next: nextBtn } = getArrowButtons();
      if (prevBtn && nextBtn) {
        let debounceTimeout = null;
        // Add a debounce delay for desktop to prevent rapid clicking scroll animation issue.
        const debounceDelay = isMobile ? 0 : 800;
        
        const prevHandler = () => {
          if (debounceTimeout) return;
          scrollToItem('prev');
          debounceTimeout = setTimeout(() => { debounceTimeout = null; }, debounceDelay);
        };
        
        const nextHandler = () => {
          if (debounceTimeout) return;
          scrollToItem('next');
          debounceTimeout = setTimeout(() => { debounceTimeout = null; }, debounceDelay);
        };
        
        prevBtn.addEventListener('click', prevHandler);
        nextBtn.addEventListener('click', nextHandler);
        arrowClickHandlers = { prev: prevHandler, next: nextHandler };
      }
    };

    const removeEventListeners = () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
      if (positionIndicator) {
        positionIndicator.removeEventListener('click', handleDotClick);
      }
      
      // Remove arrow button listeners if they exist
      if (arrowClickHandlers) {
        const { prev: currentPrevBtn, next: currentNextBtn } = getArrowButtons();
        if (currentPrevBtn) currentPrevBtn.removeEventListener('click', arrowClickHandlers.prev);
        if (currentNextBtn) currentNextBtn.removeEventListener('click', arrowClickHandlers.next);
        arrowClickHandlers = null;
      }
    };

    const initializeMobileCarousel = () => {
      createDuplicates(scrollContainer, originalItems, carousel, isMobile, desktopEnabled);
      // Calculate items per page for desktop
      if (desktopEnabled && !isMobile) {
        itemsPerPage = calculateItemsPerPage();
      }
      generateDotsWithIndicator();
      // Remove any existing listeners before adding new ones
      removeEventListeners();
      addEventListeners();
    };

    const handleResize = () => {
      if (isTransitioning) return;

      removeEventListeners();
      
      isMobile = getIsMobile();
      itemWidth = initializeItemWidth(originalItems, gapPx);
      
      const carouselNeeded = isCarouselNeeded(scrollContainer, totalItems, itemWidth);
      desktopEnabled = isDesktopEnabled(carousel);
      leftAligned = getLeftAligned(desktopEnabled, isMobile);

      if ((!desktopEnabled && !isMobile) || !carouselNeeded) {
        positionIndicator = cleanupCarousel(positionIndicator, scrollContainer, carousel);
        updateArrowVisibility(false); // Hide arrows when carousel not needed
        carousel._isResizing = false;
        isTransitioning = false;
        return;
      }

      if (desktopEnabled && !isMobile) {
        itemsPerPage = calculateItemsPerPage();
      } else {
        itemsPerPage = 1;
      }

      isTransitioning = true;
      
      applySnapClasses(originalItems, leftAligned);
      
      createDuplicates(scrollContainer, originalItems, carousel, isMobile, desktopEnabled);
      generateDotsWithIndicator();
      
      addEventListeners();
      updateArrowVisibility(true);

      // Reset to index 0 and set scroll position
      currentIndex = 0;
      requestAnimationFrame(() => {
        setScrollPosition(scrollContainer, 0, totalItems, itemWidth, gapPx, false, leftAligned);
        if (isMobile && positionIndicator) {
          updateActiveDot(positionIndicator, 0, totalItems, itemWidth, leftAligned, 0, 0);
        }
        carousel._isResizing = false;
        isTransitioning = false;
      });
    };

    const resizeObserver = createResizeObserver(carousel, handleResize);
    resizeObserver.observe(carousel);
    
    let scrollTimeout;
    let transitionTimeout;
    const handleScroll = () => {
      if (isTransitioning || carousel._isResizing) return;
      
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = scrollContainer.scrollLeft;
        const containerWidth = scrollContainer.clientWidth;
        const { start: startOfOriginals, end: endOfOriginals } = getOriginalItemBounds(totalItems, itemWidth);
        
        let startOfOriginalsWithOffset;
        if (leftAligned) {
          startOfOriginalsWithOffset = startOfOriginals - (itemWidth / 2);
        } else {
          startOfOriginalsWithOffset = startOfOriginals - ((containerWidth / 2) - (itemWidth / 2) + (gapPx / 2));
        }
        
        // Check if we need to jump from duplicates to originals
        if (scrollLeft < startOfOriginalsWithOffset || scrollLeft > endOfOriginals) {
          // We're in duplicates - jump to corresponding position in original items
          isTransitioning = true;
          const relativePosition = scrollLeft < startOfOriginalsWithOffset 
            ? scrollLeft 
            : scrollLeft - endOfOriginals;
          
          requestAnimationFrame(() => {
            scrollContainer.scrollLeft = startOfOriginals + relativePosition;
            clearTimeout(transitionTimeout);
            transitionTimeout = setTimeout(() => { 
              isTransitioning = false;
              currentIndex = updateIndicatorFromScroll(scrollContainer, positionIndicator, totalItems, itemWidth, currentIndex, leftAligned, isMobile);
            }, 100);
          });
          return;
        }
        
        currentIndex = updateIndicatorFromScroll(scrollContainer, positionIndicator, totalItems, itemWidth, currentIndex, leftAligned, isMobile);
      }, 100);
    };
    
    const handleDotClick = (event) => {
      const dot = event.target.closest('.circular-carousel-dot');
      if (!dot || isTransitioning || !positionIndicator || !isMobile) return;

      const dotIndex = parseInt(dot.getAttribute('data-index'), 10);
      if (isNaN(dotIndex)) return;
      
      isTransitioning = true;
      currentIndex = dotIndex;

      const scrollLeft = scrollContainer.scrollLeft;
      const containerWidth = scrollContainer.clientWidth;

      updateActiveDot(positionIndicator, scrollLeft, totalItems, itemWidth, leftAligned, containerWidth, dotIndex);

      requestAnimationFrame(() => {
        setScrollPosition(scrollContainer, dotIndex, totalItems, itemWidth, gapPx, true, leftAligned);
      });
      
      setTimeout(() => {
        isTransitioning = false;
      }, 400);
    };

    // Helper to get arrow buttons (cached to avoid repeated queries)
    const getArrowButtons = () => ({
      prev: carousel.querySelector('.carousel-prev'),
      next: carousel.querySelector('.carousel-next')
    });
    
    const { prev: prevBtn, next: nextBtn } = getArrowButtons();
    
    const positionArrows = () => {
      if (prevBtn && nextBtn) {
        const arrowPositionSelector = carousel.dataset.arrowPositionSelector || 'img';
        
        // Find all images, then filter to get the first rendered one (fix for firefox)
        const allImages = carousel.querySelectorAll(arrowPositionSelector);
        
        // Find the first rendered image (not in duplicate items, actually rendered)
        let firstElement = null;
        for (const img of allImages) {
          const carouselItem = img.closest('.circular-carousel-item');
          const isDuplicate = carouselItem && carouselItem.classList.contains('duplicate');
          const isHidden = carouselItem && carouselItem.hasAttribute('aria-hidden');
          const rect = img.getBoundingClientRect();
          const isRendered = rect.width > 0 && rect.height > 0;
          
          if (!isDuplicate && !isHidden && isRendered) {
            firstElement = img;
            break;
          }
        }
        
        if (firstElement) {
          // Use getBoundingClientRect for cross-browser compatibility
          // Calculate position relative to carousel container
          const elementRect = firstElement.getBoundingClientRect();
          const carouselRect = carousel.getBoundingClientRect();
          const elementTop = elementRect.top - carouselRect.top;
          const elementHeight = elementRect.height;
          
          // Find position at midpoint of element, accounting for the top padding
          const carouselItem = firstElement.closest('.circular-carousel-item');
          const itemPadding = carouselItem ? parseInt(getComputedStyle(carouselItem).paddingTop) || 0 : 0;
          const arrowPosition = elementTop + (elementHeight / 2) + itemPadding;
          
          prevBtn.style.top = `${arrowPosition}px`;
          nextBtn.style.top = `${arrowPosition}px`;
          prevBtn.style.transform = 'translateY(-50%)';
          nextBtn.style.transform = 'translateY(-50%)';
        }
      }
    };
    const updateArrowVisibility = (show = true) => {
      if (!prevBtn || !nextBtn) return;
      
      if (show) {
        prevBtn.classList.remove('hidden');
        nextBtn.classList.remove('hidden');
        carousel.classList.add('circular-carousel-fade');
        positionArrows();
      } else {
        prevBtn.classList.add('hidden');
        nextBtn.classList.add('hidden');
        carousel.classList.remove('circular-carousel-fade');
      }
    };

    const getDesktopScrollAnimationPositions = (currentScroll, targetScroll) => {
      const { start: startOfOriginals, end: endOfOriginals } = getOriginalItemBounds(totalItems, itemWidth);
      const originalItemsWidth = endOfOriginals - startOfOriginals;
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      let animationStart = currentScroll;
      let animationTarget = targetScroll;

      while (animationTarget > maxScroll && animationStart - originalItemsWidth >= 0) {
        animationStart -= originalItemsWidth;
        animationTarget -= originalItemsWidth;
      }

      while (animationTarget < 0 && animationStart + originalItemsWidth <= maxScroll) {
        animationStart += originalItemsWidth;
        animationTarget += originalItemsWidth;
      }

      return {
        animationStart,
        animationTarget,
      };
    };
    
    const scrollToItem = (direction) => {
      if (!itemWidth) return;
      
      const currentScroll = scrollContainer.scrollLeft;
      const isPrev = direction === 'prev';

      if (desktopEnabled && !isMobile) {
        isTransitioning = true;
        clearTimeout(scrollTimeout);
        clearTimeout(transitionTimeout);
        const scrollAmount = itemsPerPage * itemWidth;
        const targetScroll = isPrev ? currentScroll - scrollAmount : currentScroll + scrollAmount;
        const { animationStart, animationTarget } = getDesktopScrollAnimationPositions(currentScroll, targetScroll);

        if (Math.abs(currentScroll - animationStart) > 1) {
          scrollContainer.scrollLeft = animationStart;
        }

        scrollContainer.scrollTo({ left: animationTarget, behavior: 'smooth' });

        transitionTimeout = setTimeout(() => {
          isTransitioning = false;
          currentIndex = updateIndicatorFromScroll(scrollContainer, positionIndicator, totalItems, itemWidth, currentIndex, leftAligned, isMobile);
        }, 700);
        return;
      }

      const scrollAmount = Math.round(itemWidth + gapPx);
      const targetScroll = Math.max(0, isPrev ? currentScroll - scrollAmount : currentScroll + scrollAmount);
      scrollContainer.scrollTo({ left: targetScroll, behavior: 'smooth' });
    };

    // Initialise the carousel after a delay to allow the DOM to be fully loaded
    setTimeout(() => {
      itemWidth = initializeItemWidth(originalItems, gapPx);
      const carouselNeeded = isCarouselNeeded(scrollContainer, totalItems, itemWidth);
      const desktopEnabled = isDesktopEnabled(carousel);

      // Calculate items per page for desktop
      if (desktopEnabled && !isMobile) {
        itemsPerPage = calculateItemsPerPage();
      }

      // If desktop is not enabled, only show carousel on mobile
      // If desktop is enabled, show carousel on both mobile and desktop
      if ((desktopEnabled || isMobile) && carouselNeeded) {
        isTransitioning = true;
        currentIndex = 0;

        initializeMobileCarousel();
        updateArrowVisibility(true); // Show arrows if carousel is needed

        requestAnimationFrame(() => {
          setScrollPosition(scrollContainer, 0, totalItems, itemWidth, gapPx, false, leftAligned);
          if (isMobile && positionIndicator) {
            updateActiveDot(positionIndicator, 0, totalItems, itemWidth, leftAligned, 0, 0);
          }
          setTimeout(() => { isTransitioning = false; }, 100);
        });
      } else {
        positionIndicator = cleanupCarousel(positionIndicator, scrollContainer, carousel);
        return;
      }
    }, 150);
  };

  carousels.forEach(initCarousel);

  document.addEventListener('circular-carousel:init', (e) => {
    if (e.detail?.carousel) {
      initCarousel(e.detail.carousel);
    }
  });

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["community-comments"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__communityCommentsBound) return;
    window.__communityCommentsBound = true;

    const LABELS = window.__communityCommentsLabels || {};

    const WISHLIST_SVG =
      '<svg class="community-comments__like-icon" viewBox="0 0 22 19" fill="none" aria-hidden="true">' +
      '<path d="M11 3.55C11 3.55 12.539 1 15.9153 1C18.9254 1 21 3.54991 21 6.53788C21 10.2405 17.9004 13.8096 11 18C4.09962 13.8096 1 10.2405 1 6.53788C1 3.54991 3.07458 1 6.08475 1C9.46102 1 11 3.55 11 3.55Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="2.6131" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    const MAX_COMMENT_LENGTH = 2000;

    const hydratedCommentIds = new Set();
    const likingCommentIds = new Set();
    let hydrateTimer = null;
    let anonClientPromise = null;
    let loadMoreLoading = false;

    function clampCommentText(value) {
      return String(value ?? '').slice(0, MAX_COMMENT_LENGTH);
    }

    function commentTextFromInput(input) {
      return clampCommentText((input?.value || '').trim());
    }

    function updateCharCount(input) {
      const root = input?.closest?.('[data-reply-form], [data-comment-compose]');
      const el = root?.querySelector('[data-comment-char-count]');
      if (!el) return;
      el.textContent = `${(input.value || '').length} / ${MAX_COMMENT_LENGTH}`;
    }

    function bindCommentInput(input) {
      if (!input || input.dataset.lengthBound === '1') return;
      input.dataset.lengthBound = '1';
      input.setAttribute('maxlength', String(MAX_COMMENT_LENGTH));

      input.addEventListener('input', () => {
        if (input.value.length > MAX_COMMENT_LENGTH) {
          input.value = clampCommentText(input.value);
        }
        updateCharCount(input);
      });

      input.addEventListener('paste', (event) => {
        const paste = event.clipboardData?.getData('text');
        if (paste == null) return;
        event.preventDefault();
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? input.value.length;
        const next = clampCommentText(
          input.value.slice(0, start) + paste + input.value.slice(end)
        );
        input.value = next;
        const caret = Math.min(start + paste.length, next.length);
        try {
          input.setSelectionRange(caret, caret);
        } catch (_) { /* some inputs may not support selection */ }
        updateCharCount(input);
      });

      updateCharCount(input);
    }

    function engageRoot(el) {
      if (typeof window.communityEngageRoot === 'function') {
        return window.communityEngageRoot(el);
      }
      return el?.closest?.('[data-community-engage]') || document.querySelector('[data-community-engage]');
    }

    function engageMeta() {
      return window.__communityEngageMeta || {};
    }

    function engagementEnabled(root) {
      if (typeof window.communityEngageEngagementEnabled === 'function') {
        return window.communityEngageEngagementEnabled(root);
      }
      // Prefer shared meta (set by community-engage inline script) over
      // data-engagement-enabled — that attr is only synced when engage boots,
      // so a comments-first boot would otherwise skip hydrate.
      const flags = engageMeta();
      if (flags.engagementEnabled === true) return true;
      if (root?.dataset?.engagementEnabled === '1') return true;
      const testerId = typeof flags.testerStreamUserId === 'string' ? flags.testerStreamUserId : '';
      const userId = root?.dataset?.streamUserId || '';
      return Boolean(testerId && userId && testerId === userId);
    }

    function authenticationFlowEnabled(root) {
      if (typeof window.communityEngageAuthenticationFlowEnabled === 'function') {
        return window.communityEngageAuthenticationFlowEnabled(root);
      }
      const flags = engageMeta();
      if (typeof flags.authenticationFlowEnabled === 'boolean') {
        return flags.authenticationFlowEnabled === true && engagementEnabled(root);
      }
      return Boolean(root) && root.dataset.authenticationFlowEnabled === '1';
    }

    function hasStreamUser(root) {
      if (typeof window.communityEngageHasStreamUser === 'function') {
        return window.communityEngageHasStreamUser(root);
      }
      if (!root) return false;
      if (root.dataset.hasStreamUser === '1') return true;
      return Boolean(root.dataset.streamUserId && root.dataset.streamToken);
    }

    function canEngage(root) {
      if (typeof window.communityEngageCanEngage === 'function') {
        return window.communityEngageCanEngage(root);
      }
      return engagementEnabled(root) && hasStreamUser(root);
    }

    function shouldPromptAuth(root) {
      if (typeof window.communityEngageShouldPromptAuth === 'function') {
        return window.communityEngageShouldPromptAuth(root);
      }
      return engagementEnabled(root) && authenticationFlowEnabled(root) && !hasStreamUser(root);
    }

    function loginRedirect(returnPath) {
      if (typeof window.communityEngageLoginRedirect === 'function') {
        window.communityEngageLoginRedirect(returnPath);
        return;
      }
      const path = returnPath
        || (window.location.pathname + window.location.search + '#project-conversation');
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(path);
    }

    function conversationReturnPath() {
      const hash = '#project-conversation';
      const path = window.location.pathname + window.location.search;
      return path.includes(hash) ? path : path + hash;
    }

    function requireEngageOrRedirect(el) {
      const root = engageRoot(el);
      if (canEngage(root)) return root;
      if (shouldPromptAuth(root)) {
        loginRedirect(conversationReturnPath());
      }
      return null;
    }

    async function getUserClient(root) {
      if (typeof window.getCommunityFeedsClient === 'function') {
        return window.getCommunityFeedsClient(root);
      }
      const apiKey = root?.dataset?.apiKey || '';
      const token = root?.dataset?.streamToken || '';
      const userId = root?.dataset?.streamUserId || '';
      if (!apiKey || !token || !userId) return null;
      const { FeedsClient } = await import('https://esm.sh/@stream-io/feeds-client');
      const client = new FeedsClient(apiKey);
      await client.connectUser({ id: userId }, token);
      return client;
    }

    async function getReadClient(root) {
      if (canEngage(root)) {
        const userClient = await getUserClient(root);
        if (userClient) return userClient;
      }

      const apiKey = root?.dataset?.apiKey || '';
      if (!apiKey) return null;

      if (!anonClientPromise) {
        anonClientPromise = (async () => {
          const { FeedsClient } = await import('https://esm.sh/@stream-io/feeds-client');
          const client = new FeedsClient(apiKey);
          await client.connectAnonymous();
          return client;
        })().catch((err) => {
          anonClientPromise = null;
          throw err;
        });
      }
      return anonClientPromise;
    }

    function activityId() {
      return (
        document.querySelector('[data-comment-compose]')?.dataset?.activityId
        || document.querySelector('[data-project-id]')?.dataset?.projectId
        || ''
      );
    }

    function authorId() {
      return engageRoot(document.body)?.dataset?.authorId || '';
    }

    function proxyUrl() {
      return engageRoot(document.body)?.dataset?.proxyUrl || '';
    }

    function locale() {
      return engageRoot(document.body)?.dataset?.locale || 'en-us';
    }

    function currentUser() {
      const root = engageRoot(document.body);
      const composeImg = document.querySelector('[data-comment-compose] img');
      return {
        id: root?.dataset?.streamUserId || '',
        name: root?.dataset?.streamUserName || composeImg?.getAttribute('alt') || '',
        image: root?.dataset?.streamUserImage || composeImg?.getAttribute('src') || '',
      };
    }

    function viewerAvatarHtml() {
      const me = currentUser();
      const src = me.image || LABELS.placeholderAvatar || '';
      const alt = displayName(me.name);
      const href = me.id ? userProfileUrl(me.id) : '';
      return `
        <div class="community-comments__avatar">
          ${href ? `<a href="${esc(href)}">` : ''}
          <img src="${esc(src)}" alt="${esc(alt)}" width="80" height="80" loading="lazy">
          ${href ? '</a>' : ''}
        </div>`;
    }

    function esc(str) {
      return String(str ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function relativeTime(dateStr) {
      if (!dateStr) return '';
      const t = new Date(dateStr).getTime();
      if (!Number.isFinite(t)) return '';
      const diff = Date.now() - t;
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return 'just now';
      if (mins < 60) return `${mins}m ago`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return `${hrs}h ago`;
      const days = Math.floor(hrs / 24);
      if (days < 30) return `${days}d ago`;
      const months = Math.round(days / 30);
      return `${months} month${months === 1 ? '' : 's'} ago`;
    }

    function formatCommentTimeLabel(dateStr) {
      const label = relativeTime(dateStr);
      return label ? `· ${label}` : '';
    }

    function hydrateCommentTimes(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-comment-time]').forEach((el) => {
        if (el.dataset.timeHydrated === '1' && el.textContent.trim()) return;
        const iso = el.getAttribute('data-comment-time') || el.getAttribute('datetime') || '';
        const label = formatCommentTimeLabel(iso);
        if (!label) return;
        el.textContent = label;
        el.dataset.timeHydrated = '1';
      });
    }

    function displayName(name) {
      const trimmed = String(name || '').trim();
      return trimmed || LABELS.anonymous;
    }

    function userProfileUrl(userId) {
      const base = proxyUrl().replace(/\/$/, '');
      const loc = locale();
      const q = loc && loc !== 'en-us' ? `?locale=${encodeURIComponent(loc)}` : '';
      return `${base}/users/${userId}${q}`;
    }

    function indentClass(depth) {
      return Number(depth) > 0 ? 'community-comments__row--indent' : '';
    }

    function repliesLabel(count) {
      const n = Number(count) || 0;
      if (n === 1) return LABELS.viewReply;
      return String(LABELS.viewReplies || '').replace('__COUNT__', String(n));
    }

    function replyCountFrom(comment) {
      const n = comment?.reply_count ?? comment?.replyCount;
      return typeof n === 'number' && Number.isFinite(n) ? n : 0;
    }

    function commentRow(el) {
      return el?.closest?.('.project-comment') || null;
    }

    function setLiked(btn, liked) {
      if (liked) btn.dataset.liked = 'true';
      else delete btn.dataset.liked;
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    }

    function setLikeCount(btn, count) {
      const el = btn.querySelector('[data-like-count]');
      if (!el || typeof count !== 'number' || !Number.isFinite(count)) return;
      const n = Math.max(0, count);
      el.textContent = String(n);
      el.dataset.likeCount = String(n);
    }

    function readLikeCount(btn) {
      const el = btn.querySelector('[data-like-count]');
      if (!el) return 0;
      const fromData = parseInt(el.dataset.likeCount || '', 10);
      if (Number.isFinite(fromData)) return fromData;
      const fromText = parseInt((el.textContent || '').trim(), 10);
      return Number.isFinite(fromText) ? fromText : 0;
    }

    function adjustLikeCount(btn, delta) {
      setLikeCount(btn, Math.max(0, readLikeCount(btn) + delta));
    }

    function hasOwnLike(comment) {
      const own = comment?.own_reactions || comment?.ownReactions || [];
      return own.some((r) => (r.type || r.reaction_type || 'like') === 'like');
    }

    function reactionCountFrom(comment) {
      if (!comment || typeof comment !== 'object') return null;
      // Prefer the like group so we don't pick up unrelated reaction types
      const groups = comment.reaction_groups || comment.reactionGroups || {};
      const likeGroup = groups.like;
      const groupCount = likeGroup?.count ?? likeGroup?.Count;
      if (typeof groupCount === 'number' && Number.isFinite(groupCount)) return groupCount;
      // Prefer reaction_count over upvote_count — upvote_count is often 0 for type:"like"
      // and `0 ?? reaction_count` would incorrectly win with nullish coalescing.
      const reaction = comment.reaction_count ?? comment.reactionCount;
      if (typeof reaction === 'number' && Number.isFinite(reaction)) return reaction;
      const upvotes = comment.upvote_count ?? comment.upvoteCount;
      return typeof upvotes === 'number' && Number.isFinite(upvotes) ? upvotes : null;
    }

    function bumpHeaderCount(delta) {
      const el = document.querySelector('.project_comment_count');
      if (!el) return;
      const match = (el.textContent || '').match(/(\d+)/);
      const current = match ? parseInt(match[1], 10) : 0;
      const next = Math.max(0, current + delta);
      el.textContent = `(${next})`;
    }

    /** Remove a comment. Deleting a root also drops its loaded replies and paging button. */
    function removeCommentThread(row) {
      if (!row) return 0;
      const depth = parseInt(row.dataset.depth || '0', 10);
      const doomed = [row];
      if (depth === 0) {
        const threadId = row.dataset.commentId || '';
        let next = row.nextElementSibling;
        while (next) {
          const isReply = next.classList.contains('project-comment')
            && next.dataset.depth === '1'
            && next.dataset.threadId === threadId;
          const isMore = next.matches?.('[data-action="comment-replies-more"]')
            && next.dataset.threadId === threadId;
          if (!isReply && !isMore) break;
          doomed.push(next);
          next = next.nextElementSibling;
        }
      }
      let removed = 0;
      for (const el of doomed) {
        if (el.classList.contains('project-comment')) {
          const id = el.dataset.commentId;
          if (id) hydratedCommentIds.delete(id);
          removed += 1;
        }
        el.remove();
      }
      return removed;
    }

    function buildCommentEl(opts) {
      const {
        id,
        text,
        userId,
        userName,
        userImage,
        createdAt,
        likeCount = 0,
        depth = 0,
        threadId = '',
        mention = null,
        liked = false,
      } = opts;

      const depthNum = Number(depth) > 0 ? 1 : 0;
      const name = displayName(userName);
      const href = userProfileUrl(userId);
      const avatarSrc = userImage || LABELS.placeholderAvatar || '';
      const createdAtIso = createdAt ? String(createdAt) : '';
      const createdAtLabel = formatCommentTimeLabel(createdAtIso);
      const isMaker = authorId() && userId && authorId() === userId;
      const indent = indentClass(depthNum);
      const me = currentUser().id;
      const canDelete = Boolean(userId && me && userId === me);
      const rootId = depthNum === 0 ? (id || threadId) : threadId;
      const engage = engageRoot(document.body);
      const canWrite = canEngage(engage);
      const showAuthPrompt = shouldPromptAuth(engage);
      const showInteractive = canWrite || showAuthPrompt;
      // Mentions only render when we have a real name — never fall back to Anonymous.
      const mentionLabel = mention?.id && mention.id !== userId
        ? String(mention.name || '').trim()
        : '';
      const mentionHref = mentionLabel ? userProfileUrl(mention.id) : '';

      const wrap = document.createElement('div');
      wrap.dataset.commentId = id || '';
      wrap.dataset.userId = userId || '';
      wrap.dataset.userName = name || '';
      wrap.dataset.threadId = rootId || '';
      wrap.dataset.depth = String(depthNum);
      wrap.className = `project-comment${depthNum > 0 ? ' community-comments__thread-border' : ''}`;

      const likeMarkup = (!showInteractive || (userId && me && userId === me))
        ? `<span class="community-comments__like" aria-label="${esc(LABELS.like)}">${WISHLIST_SVG}<span class="community-comments__like-count">${esc(LABELS.like)} · <span data-like-count="${Number(likeCount) || 0}">${Number(likeCount) || 0}</span></span></span>`
        : `<button type="button" data-action="comment-like" data-comment-id="${esc(id)}" class="community-comments__like" aria-label="${esc(LABELS.like)}" aria-pressed="false">${WISHLIST_SVG}<span class="community-comments__like-count">${esc(LABELS.like)} · <span data-like-count="${Number(likeCount) || 0}">${Number(likeCount) || 0}</span></span></button>`;

      wrap.innerHTML = `
        <div class="community-comments__row${indent ? ` ${indent}` : ''}">
          <div class="community-comments__avatar">
            ${userId ? `<a href="${esc(href)}">` : ''}
            <img src="${esc(avatarSrc)}" alt="${esc(name)}" width="80" height="80" loading="lazy">
            ${userId ? '</a>' : ''}
          </div>
          <div class="community-comments__content">
            <div class="community-comments__meta">
              ${userId
                ? `<a href="${esc(href)}" class="community-comments__author">${esc(name)}</a>`
                : `<span class="community-comments__author">${esc(name)}</span>`}
              ${canDelete && LABELS.you
                ? `<span class="community-comments__you">${esc(LABELS.you)}</span>`
                : ''}
              ${isMaker && LABELS.makerTag
                ? `<div class="community-comments__maker-tag">${esc(LABELS.makerTag)}</div>`
                : ''}
              ${createdAtIso
                ? `<time class="community-comments__time" datetime="${esc(createdAtIso)}" data-comment-time="${esc(createdAtIso)}" data-time-hydrated="1">${esc(createdAtLabel)}</time>`
                : ''}
            </div>
            <p class="community-comments__body" data-comment-body>${mentionLabel ? `<a href="${esc(mentionHref)}" class="community-comments__mention">@${esc(mentionLabel)}</a> ` : ''}${esc(text || '')}</p>
            <div class="community-comments__actions">
              ${canWrite
                ? `<button type="button" data-action="comment-reply" data-comment-id="${esc(id)}" data-depth="${depthNum}" class="community-comments__action">${esc(LABELS.reply)}</button>`
                : ''}
              ${likeMarkup}
              ${canWrite && canDelete
                ? `<button type="button" data-action="comment-delete" data-comment-id="${esc(id)}" class="community-comments__action community-comments__action--delete">${esc(LABELS.delete)}</button>`
                : ''}
            </div>
            <div data-reply-form-slot class="community-comments__reply-slot hidden"></div>
            <p data-comment-error class="community-comments__error hidden" role="alert"></p>
          </div>
        </div>`;

      const likeBtn = wrap.querySelector('[data-action="comment-like"]');
      if (likeBtn && liked) setLiked(likeBtn, true);

      return wrap;
    }

    function buildRepliesButton(threadId, count) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.action = 'comment-replies-more';
      btn.dataset.threadId = threadId || '';
      btn.dataset.replyCount = String(Number(count) || 0);
      btn.className = 'community-comments__view-replies';
      btn.textContent = repliesLabel(count);
      return btn;
    }

    function appendTopLevel(list, comment) {
      const node = buildCommentEl({
        id: comment.id,
        text: comment.text || comment.comment || '',
        userId: comment.user?.id || '',
        userName: comment.user?.name || '',
        userImage: comment.user?.image || '',
        createdAt: comment.created_at || comment.createdAt || '',
        likeCount: reactionCountFrom(comment) ?? 0,
        depth: 0,
        threadId: comment.id,
        liked: hasOwnLike(comment),
      });
      list.appendChild(node);
      // Leave out of hydratedCommentIds — scheduleHydrate applies own likes via
      // batchQueryCommentReactions (getComments does not reliably include them).
      const replies = replyCountFrom(comment);
      if (replies > 0 && comment.id) list.appendChild(buildRepliesButton(comment.id, replies));
    }

    function createdTime(comment) {
      const raw = comment?.created_at || comment?.createdAt;
      const t = raw ? new Date(raw).getTime() : 0;
      return Number.isFinite(t) ? t : 0;
    }

    function mentionFrom(comment) {
      const users = comment?.mentioned_users || comment?.mentionedUsers || [];
      const user = users[0];
      if (!user?.id) return null;
      return { id: user.id, name: user.name || '' };
    }

    /**
     * Collapse a reply tree into one oldest-to-newest list.
     * Only stored mentions are shown — older replies without mentioned_users
     * render with no @ prefix.
     */
    function flattenThread(replies) {
      const flat = [];
      for (const reply of replies || []) {
        const authorId = reply.user?.id || '';
        const tagged = mentionFrom(reply);
        flat.push({
          comment: reply,
          mention: tagged?.id && tagged.id !== authorId ? tagged : null,
          ts: createdTime(reply),
        });
        flat.push(...flattenThread(reply.replies || []));
      }
      return flat;
    }

    function flattenThreadSorted(replies) {
      return flattenThread(replies || []).sort((a, b) => a.ts - b.ts);
    }

    function cssId(value) {
      const id = String(value || '');
      if (window.CSS?.escape) return CSS.escape(id);
      return id.replace(/"/g, '\\"');
    }

    function threadParts(threadId) {
      const list = document.getElementById('comment-list');
      if (!list || !threadId) return { list, root: null, more: null };
      const root = list.querySelector(`:scope > .project-comment[data-comment-id="${cssId(threadId)}"]`);
      const more = list.querySelector(`:scope > [data-action="comment-replies-more"][data-thread-id="${cssId(threadId)}"]`);
      return { list, root, more };
    }

    /** Newest reply sits at the bottom of the thread, below any paging button. */
    function appendToThread(threadId, el) {
      const { list, root, more } = threadParts(threadId);
      if (!list || !root) {
        list?.appendChild(el);
        return;
      }

      let anchor = more || root;
      let next = anchor.nextElementSibling;
      while (next && next.classList.contains('project-comment') && next.dataset.threadId === threadId && next.dataset.depth === '1') {
        anchor = next;
        next = next.nextElementSibling;
      }
      if (anchor.nextElementSibling) list.insertBefore(el, anchor.nextElementSibling);
      else list.appendChild(el);
    }

    function rowAuthorName(row) {
      return row?.dataset?.userName?.trim()
        || row?.querySelector('.community-comments__author')?.textContent?.trim()
        || '';
    }

    function reactionCommentId(reaction) {
      return reaction?.comment_id || reaction?.commentId || '';
    }

    /**
     * Own-like state via batchQueryCommentReactions; counts via queryComments
     * for the same ids (batch reactions has no counts; comment list reads have
     * no reliable own_reactions). Mirrors community-engage activity hydrate.
     *
     * Like buttons are collected page-wide: conversation markup can sit
     * outside [data-community-engage] when the browser auto-closes the
     * section early. Credentials still come from `root`.
     */
    async function hydrateCommentLikes(root) {
      if (!canEngage(root)) return;

      // Page-wide — do not scope to root (see comment above).
      const buttons = [...document.querySelectorAll('[data-action="comment-like"]')].filter(
        (btn) => btn.dataset.commentId && !hydratedCommentIds.has(btn.dataset.commentId)
      );
      if (!buttons.length) return;

      const byId = new Map();
      for (const btn of buttons) {
        const id = btn.dataset.commentId;
        if (!byId.has(id)) byId.set(id, []);
        byId.get(id).push(btn);
      }
      const ids = [...byId.keys()];

      try {
        const client = await getUserClient(root);
        if (!client) return;

        if (typeof client.batchQueryCommentReactions !== 'function') {
          console.error('[community-comments] batchQueryCommentReactions unavailable on client');
          return;
        }

        const likedIds = new Set();
        const countsById = new Map();
        const chunkSize = 100;

        for (let i = 0; i < ids.length; i += chunkSize) {
          const chunk = ids.slice(i, i + chunkSize);

          const [reactionsData, commentsData] = await Promise.all([
            client.batchQueryCommentReactions({
              comment_ids: chunk,
              filter: { reaction_type: 'like' },
            }),
            client.queryComments({
              filter: { id: { $in: chunk } },
              limit: Math.min(100, chunk.length),
            }),
          ]);

          for (const reaction of reactionsData?.reactions || []) {
            const commentId = reactionCommentId(reaction);
            if (commentId) likedIds.add(commentId);
          }

          for (const comment of commentsData?.comments || []) {
            const id = comment?.id;
            if (!id) continue;
            const count = reactionCountFrom(comment);
            if (count != null) countsById.set(id, count);
          }
        }

        for (const id of ids) {
          // Don't clobber an in-flight optimistic like with a stale hydrate payload
          if (likingCommentIds.has(id)) continue;
          hydratedCommentIds.add(id);
          const liked = likedIds.has(id);
          const count = countsById.get(id);
          for (const btn of byId.get(id) || []) {
            setLiked(btn, liked);
            if (count != null) setLikeCount(btn, count);
          }
        }
      } catch (err) {
        console.error('[community-comments] hydrate failed', err);
      }
    }

    function scheduleHydrate(root) {
      clearTimeout(hydrateTimer);
      hydrateTimer = setTimeout(() => hydrateCommentLikes(root), 50);
    }

    async function toggleCommentLike(btn) {
      const root = requireEngageOrRedirect(btn);
      if (!root) return;

      const row = commentRow(btn);
      const commentId = btn.dataset.commentId || row?.dataset?.commentId || '';
      if (!commentId) return;
      if (row?.dataset?.userId && row.dataset.userId === currentUser().id) return;
      if (likingCommentIds.has(commentId) || btn.dataset.liking === 'true') return;
      likingCommentIds.add(commentId);
      btn.dataset.liking = 'true';

      const wasLiked = 'liked' in btn.dataset;
      const baseCount = readLikeCount(btn);
      const nextCount = Math.max(0, baseCount + (wasLiked ? -1 : 1));
      setLiked(btn, !wasLiked);
      // Keep the optimistic count — do not overwrite with the API total on success.
      // SSR comment likes are cached up to 30 days, so the server total can jump
      // (e.g. 0 → 3) and look like the click added 3 likes.
      setLikeCount(btn, nextCount);

      try {
        const client = await getUserClient(root);
        if (!client) {
          loginRedirect(conversationReturnPath());
          return;
        }

        if (wasLiked) {
          await client.deleteCommentReaction({
            id: commentId,
            type: 'like',
          });
        } else {
          await client.addCommentReaction({
            id: commentId,
            type: 'like',
            enforce_unique: true,
          });
        }

        hydratedCommentIds.add(commentId);
      } catch (err) {
        setLiked(btn, wasLiked);
        setLikeCount(btn, baseCount);
        console.error('[community-comments] like failed', err);
      } finally {
        delete btn.dataset.liking;
        likingCommentIds.delete(commentId);
      }
    }

    function closeReplyForms(exceptSlot) {
      document.querySelectorAll('[data-reply-form-slot]').forEach((slot) => {
        if (slot === exceptSlot) return;
        slot.classList.add('hidden');
        slot.innerHTML = '';
      });
    }

    function openReplyForm(btn) {
      const root = requireEngageOrRedirect(btn);
      if (!root) return;

      // Must use .project-comment — the reply button also has data-comment-id,
      // so closest('[data-comment-id]') would match the button itself and miss the slot.
      const row = commentRow(btn);
      const slot = row?.querySelector('[data-reply-form-slot]');
      if (!slot) return;

      if (!slot.classList.contains('hidden') && slot.innerHTML.trim()) {
        slot.classList.add('hidden');
        slot.innerHTML = '';
        return;
      }

      const depth = parseInt(btn.dataset.depth || row?.dataset?.depth || '0', 10);
      const threadId = depth > 0
        ? (row?.dataset?.threadId || '')
        : (btn.dataset.commentId || row?.dataset?.commentId || '');
      const targetUserId = row?.dataset?.userId || '';
      const targetName = rowAuthorName(row);
      const me = currentUser().id;
      const isSelf = Boolean(targetUserId && targetUserId === me);
      const visibleTag = targetUserId && !isSelf
        ? { id: targetUserId, name: targetName }
        : null;
      // A reply to your own sub-comment stores a self-mention so reload does
      // not treat a missing mention as "reply to the original comment".
      const storedMentionId = visibleTag?.id || (depth > 0 && isSelf ? me : '');
      const placeholder = !isSelf && targetName
        ? String(LABELS.replyTo || '').replace('__NAME__', targetName)
        : LABELS.replyPlaceholder;

      closeReplyForms(slot);
      slot.classList.remove('hidden');
      slot.innerHTML = `
        <div class="community-comments__reply-form" data-reply-form data-parent-id="${esc(threadId)}" data-mention-id="${esc(storedMentionId)}" data-mention-name="${esc(visibleTag?.name || '')}">
          ${viewerAvatarHtml()}
          <div class="community-comments__reply-fields">
            <textarea rows="2" data-reply-input class="community-comments__reply-input" maxlength="${MAX_COMMENT_LENGTH}" placeholder="${esc(placeholder)}"></textarea>
            <div class="community-comments__reply-actions">
              <button type="button" data-action="comment-reply-submit" class="community-comments__button">${esc(LABELS.post)}</button>
              <button type="button" data-action="comment-reply-cancel" class="community-comments__cancel">Cancel</button>
              <span data-comment-char-count class="community-comments__char-count" aria-live="polite">0 / ${MAX_COMMENT_LENGTH}</span>
            </div>
          </div>
        </div>`;
      const replyInput = slot.querySelector('[data-reply-input]');
      bindCommentInput(replyInput);
      replyInput?.focus();
    }

    function showRowError(row, message) {
      const err = row?.querySelector('[data-comment-error]');
      if (!err) return;
      err.textContent = message || LABELS.error;
      err.classList.remove('hidden');
    }

    function clearRowError(row) {
      const err = row?.querySelector('[data-comment-error]');
      if (!err) return;
      err.textContent = '';
      err.classList.add('hidden');
    }

    async function submitReply(submitBtn) {
      const form = submitBtn.closest('[data-reply-form]');
      const parentRow = commentRow(submitBtn);
      const root = requireEngageOrRedirect(submitBtn);
      if (!root || !form) return;

      const input = form.querySelector('[data-reply-input]');
      const text = commentTextFromInput(input);
      if (!text) return;
      if (input && input.value !== text) input.value = text;

      const parentId = form.dataset.parentId || '';
      const mentionId = form.dataset.mentionId || '';
      const mentionName = form.dataset.mentionName || '';
      if (!parentId) return;

      clearRowError(parentRow);
      submitBtn.disabled = true;

      const me = currentUser();
      const tempId = `temp-${Date.now()}`;
      const optimistic = buildCommentEl({
        id: tempId,
        text,
        userId: me.id,
        userName: displayName(me.name),
        userImage: me.image,
        createdAt: new Date().toISOString(),
        likeCount: 0,
        depth: 1,
        threadId: parentId,
        mention: mentionId ? { id: mentionId, name: mentionName } : null,
        liked: false,
      });
      optimistic.dataset.optimistic = 'true';
      appendToThread(parentId, optimistic);

      const slot = parentRow?.querySelector('[data-reply-form-slot]');
      if (slot) {
        slot.classList.add('hidden');
        slot.innerHTML = '';
      }

      try {
        const client = await getUserClient(root);
        if (!client) {
          optimistic.remove();
          loginRedirect(conversationReturnPath());
          return;
        }

        const payload = {
          comment: text,
          parent_id: parentId,
        };
        if (mentionId) payload.mentioned_user_ids = [mentionId];

        const response = await client.addComment(payload);

        const created = response?.comment || response;
        const realId = created?.id || tempId;
        optimistic.dataset.commentId = realId;
        optimistic.querySelectorAll('[data-comment-id]').forEach((el) => {
          el.dataset.commentId = realId;
        });
        delete optimistic.dataset.optimistic;
        hydratedCommentIds.add(realId);
        bumpHeaderCount(1);
      } catch (err) {
        console.error('[community-comments] reply failed', err);
        optimistic.remove();
        showRowError(parentRow, LABELS.error);
      } finally {
        submitBtn.disabled = false;
      }
    }

    async function submitCompose(submitBtn) {
      const root = requireEngageOrRedirect(submitBtn);
      if (!root) return;

      const compose = submitBtn.closest('[data-comment-compose]');
      const input = compose?.querySelector('[data-comment-compose-input]');
      const errEl = compose?.querySelector('[data-compose-error]');
      const text = commentTextFromInput(input);
      if (!text) return;
      if (input && input.value !== text) input.value = text;

      const objectId = compose?.dataset?.activityId || activityId();
      if (!objectId) return;

      if (errEl) {
        errEl.textContent = '';
        errEl.classList.add('hidden');
      }
      submitBtn.disabled = true;

      const list = document.getElementById('comment-list');
      const me = currentUser();
      const tempId = `temp-${Date.now()}`;
      const optimistic = buildCommentEl({
        id: tempId,
        text,
        userId: me.id,
        userName: displayName(me.name),
        userImage: me.image,
        createdAt: new Date().toISOString(),
        likeCount: 0,
        depth: 0,
        liked: false,
      });
      optimistic.dataset.optimistic = 'true';

      // sort: last → newest first
      if (list?.firstChild) list.insertBefore(optimistic, list.firstChild);
      else list?.appendChild(optimistic);
      if (input) {
        input.value = '';
        updateCharCount(input);
      }

      try {
        const client = await getUserClient(root);
        if (!client) {
          optimistic.remove();
          loginRedirect(conversationReturnPath());
          return;
        }

        const response = await client.addComment({
          comment: text,
          object_id: objectId,
          object_type: 'activity',
        });

        const created = response?.comment || response;
        const realId = created?.id || tempId;
        optimistic.dataset.commentId = realId;
        optimistic.dataset.threadId = realId;
        optimistic.querySelectorAll('[data-comment-id]').forEach((el) => {
          el.dataset.commentId = realId;
        });
        delete optimistic.dataset.optimistic;
        hydratedCommentIds.add(realId);
        bumpHeaderCount(1);
      } catch (err) {
        console.error('[community-comments] compose failed', err);
        optimistic.remove();
        if (errEl) {
          errEl.textContent = LABELS.error;
          errEl.classList.remove('hidden');
        }
        if (input) {
          input.value = text;
          updateCharCount(input);
        }
      } finally {
        submitBtn.disabled = false;
      }
    }

    async function deleteOwnComment(btn) {
      const root = requireEngageOrRedirect(btn);
      if (!root) return;

      const commentId = btn.dataset.commentId || '';
      const row = commentRow(btn);
      if (!commentId || !row) return;

      const me = currentUser().id;
      const ownerId = row.dataset.userId || '';
      if (!me || !ownerId || me !== ownerId) return;

      if (!window.confirm(LABELS.deleteConfirm)) return;

      btn.disabled = true;
      clearRowError(row);

      try {
        const client = await getUserClient(root);
        if (!client) {
          btn.disabled = false;
          loginRedirect(conversationReturnPath());
          return;
        }

        await client.deleteComment({ id: commentId });
        const removed = removeCommentThread(row);
        bumpHeaderCount(-removed);
      } catch (err) {
        console.error('[community-comments] delete failed', err);
        showRowError(row, LABELS.error);
        btn.disabled = false;
      }
    }

    async function loadMore(btn) {
      if (loadMoreLoading) return;
      const next = btn.dataset.next || '';
      if (!next) return;

      const list = document.getElementById('comment-list');
      const objectId = activityId();
      if (!list || !objectId) return;

      const root = engageRoot(btn);
      loadMoreLoading = true;
      btn.disabled = true;
      const label = btn.textContent.trim() || LABELS.more;
      btn.textContent = LABELS.loading;

      try {
        const client = await getReadClient(root);
        if (!client) throw new Error('no client');

        const res = await client.getComments({
          object_id: objectId,
          object_type: 'activity',
          depth: 1,
          sort: 'last',
          replies_limit: 0,
          limit: 10,
          next,
        });

        const incoming = res?.comments || [];
        for (const c of incoming) appendTopLevel(list, c);

        const nextCursor = res?.next || null;
        if (!nextCursor) {
          btn.remove();
        } else {
          btn.dataset.next = nextCursor;
          btn.textContent = label;
          btn.disabled = false;
        }

        scheduleHydrate(root);
      } catch (err) {
        console.error('[community-comments] load more failed', err);
        btn.textContent = label;
        btn.disabled = false;
      } finally {
        loadMoreLoading = false;
      }
    }

    async function loadThreadReplies(btn) {
      if (btn.dataset.loading === '1') return;
      const threadId = btn.dataset.threadId || '';
      if (!threadId) return;

      const list = document.getElementById('comment-list');
      const root = engageRoot(btn);
      if (!list) return;

      btn.dataset.loading = '1';
      btn.disabled = true;
      const previous = btn.textContent;
      btn.textContent = LABELS.loading;

      try {
        const client = await getReadClient(root);
        if (!client) throw new Error('no client');

        const request = {
          id: threadId,
          depth: 3,
          sort: 'first',
          replies_limit: 20,
          limit: 10,
        };
        if (btn.dataset.next) request.next = btn.dataset.next;

        const res = await client.getCommentReplies(request);
        const page = flattenThreadSorted(res?.comments || res?.replies || []);
        const seen = new Set(
          [...list.querySelectorAll(`:scope > .project-comment[data-thread-id="${cssId(threadId)}"]`)]
            .map((el) => el.dataset.commentId)
        );

        for (const item of page) {
          const id = item.comment?.id;
          if (!id || seen.has(id)) continue;
          seen.add(id);
          const authorId = item.comment.user?.id || '';
          const mention = item.mention?.id && item.mention.id !== authorId ? item.mention : null;
          const node = buildCommentEl({
            id,
            text: item.comment.text || item.comment.comment || '',
            userId: item.comment.user?.id || '',
            userName: item.comment.user?.name || '',
            userImage: item.comment.user?.image || '',
            createdAt: item.comment.created_at || item.comment.createdAt || '',
            likeCount: reactionCountFrom(item.comment) ?? 0,
            depth: 1,
            threadId,
            mention,
            liked: hasOwnLike(item.comment),
          });
          list.insertBefore(node, btn);
          // Don't mark hydrated here — scheduleHydrate owns own-like state.
        }

        const nextCursor = res?.next || '';
        if (!nextCursor) {
          btn.remove();
        } else {
          btn.dataset.next = nextCursor;
          btn.dataset.opened = '1';
          btn.textContent = LABELS.viewMoreReplies;
          btn.disabled = false;
        }

        scheduleHydrate(root);
      } catch (err) {
        console.error('[community-comments] load replies failed', err);
        btn.textContent = previous;
        btn.disabled = false;
      } finally {
        delete btn.dataset.loading;
      }
    }

    document.addEventListener('click', (event) => {
      const actionEl = event.target.closest('[data-action]');
      const action = actionEl?.dataset?.action || '';

      // Strict equality — attribute selectors must not treat comment-like as comment
      if (action === 'comment-sign-in') {
        event.preventDefault();
        event.stopPropagation();
        if (shouldPromptAuth(engageRoot(actionEl || document.body))) {
          loginRedirect(conversationReturnPath());
        }
        return;
      }

      if (action === 'comment-like') {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleCommentLike(actionEl);
        return;
      }

      if (action === 'comment-reply') {
        event.preventDefault();
        event.stopPropagation();
        openReplyForm(actionEl);
        return;
      }

      if (action === 'comment-replies-more') {
        event.preventDefault();
        event.stopPropagation();
        loadThreadReplies(actionEl);
        return;
      }

      if (action === 'comment-delete') {
        event.preventDefault();
        event.stopPropagation();
        deleteOwnComment(actionEl);
        return;
      }

      if (action === 'comment-reply-cancel') {
        event.preventDefault();
        event.stopPropagation();
        const slot = actionEl.closest('[data-reply-form-slot]');
        if (slot) {
          slot.classList.add('hidden');
          slot.innerHTML = '';
        }
        return;
      }

      if (action === 'comment-reply-submit') {
        event.preventDefault();
        event.stopPropagation();
        submitReply(actionEl);
        return;
      }

      if (action === 'comment-compose-submit') {
        event.preventDefault();
        event.stopPropagation();
        submitCompose(actionEl);
        return;
      }

      const moreBtn = event.target.closest('#load-more-comments');
      if (moreBtn) {
        event.preventDefault();
        event.stopPropagation();
        loadMore(moreBtn);
      }
    });

    function boot() {
      const root = engageRoot(document.body);
      hydrateCommentTimes(document);
      document.querySelectorAll('[data-comment-compose-input]').forEach(bindCommentInput);
      if (!root) return;
      hydrateCommentLikes(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('[data-comment-time]') || node.querySelector?.('[data-comment-time]')) {
            hydrateCommentTimes(node);
          }
          const root = engageRoot(node) || (node.matches?.('[data-community-engage]') ? node : null);
          if (!root) continue;
          const hasLike =
            node.matches?.('[data-action="comment-like"]')
            || node.querySelector?.('[data-action="comment-like"]');
          if (hasLike) scheduleHydrate(root);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["community-engage"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__communityEngageBound) return;
    window.__communityEngageBound = true;

    const hydratedIds = new Set();
    let hydrateTimer = null;
    let clientPromise = null;
    let followBusy = false;
    const HYDRATE_DEBUG = Boolean(window.__communityEngageDebug);

    function logDebug(...args) {
      if (HYDRATE_DEBUG) console.info('[community-engage]', ...args);
    }

    function meta() {
      return window.__communityEngageMeta || {};
    }

    function engageRoot(el) {
      return el.closest('[data-community-engage]') || document.querySelector('[data-community-engage]');
    }

    function credentials(root) {
      if (!root) return null;
      const apiKey = root.dataset.apiKey || '';
      const token = root.dataset.streamToken || '';
      const userId = root.dataset.streamUserId || '';
      if (!apiKey || !token || !userId) return null;
      return { apiKey, token, userId };
    }

    function engagementEnabled(root) {
      if (!root) return false;
      const flags = meta();
      if (flags.engagementEnabled === true) return true;
      const testerId = typeof flags.testerStreamUserId === 'string' ? flags.testerStreamUserId : '';
      const userId = root.dataset.streamUserId || '';
      return Boolean(testerId && userId && testerId === userId);
    }

    function authenticationFlowEnabled(root) {
      return meta().authenticationFlowEnabled === true && engagementEnabled(root);
    }

    function syncFlagAttrs(root) {
      if (!root) return;
      if (engagementEnabled(root)) {
        root.dataset.engagementEnabled = '1';
      } else {
        delete root.dataset.engagementEnabled;
      }
      if (authenticationFlowEnabled(root)) {
        root.dataset.authenticationFlowEnabled = '1';
      } else {
        delete root.dataset.authenticationFlowEnabled;
      }
    }

    function hasStreamUser(root) {
      if (!root) return false;
      if (root.dataset.hasStreamUser === '1') return true;
      return Boolean(root.dataset.streamUserId && root.dataset.streamToken);
    }

    function canEngage(root) {
      return engagementEnabled(root) && hasStreamUser(root);
    }

    function hydrateSkipReason(root) {
      if (!root) return 'no [data-community-engage] root';
      if (!engagementEnabled(root)) return 'engagement_enabled metafield is off';
      if (!hasStreamUser(root)) return 'no stream user credentials on the page';
      if (!credentials(root)) return 'api key / token / user id incomplete';
      return null;
    }

    function shouldPromptAuth(root) {
      return engagementEnabled(root) && authenticationFlowEnabled(root) && !hasStreamUser(root);
    }

    function loginRedirect(returnPath) {
      const path = returnPath
        || (window.location.pathname + window.location.search + window.location.hash);
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(path);
    }

    async function getClient(root) {
      const creds = credentials(root);
      if (!creds) return null;

      if (!clientPromise) {
        clientPromise = (async () => {
          const { FeedsClient } = await import('https://esm.sh/@stream-io/feeds-client');
          const client = new FeedsClient(creds.apiKey);
          await client.connectUser({ id: creds.userId }, creds.token);
          return client;
        })().catch((err) => {
          clientPromise = null;
          throw err;
        });
      }

      return clientPromise;
    }

    // Shared with community-comments — do not open a second connectUser session.
    window.getCommunityFeedsClient = getClient;
    window.communityEngageCanEngage = canEngage;
    window.communityEngageEngagementEnabled = engagementEnabled;
    window.communityEngageAuthenticationFlowEnabled = authenticationFlowEnabled;
    window.communityEngageShouldPromptAuth = shouldPromptAuth;
    window.communityEngageHasStreamUser = hasStreamUser;
    window.communityEngageLoginRedirect = loginRedirect;
    window.communityEngageRoot = engageRoot;

    function activityIdFor(btn) {
      return btn.dataset.activityId || btn.closest('[data-activity-id]')?.dataset.activityId || '';
    }

    function likeButtons(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      return [...root.querySelectorAll('[data-action="like"]')].filter((btn) => {
        const id = activityIdFor(btn);
        return id && id !== 'x';
      });
    }

    function likeCountEl(btn) {
      return (
        btn.querySelector('[data-like-count]') ||
        btn.closest('[data-action-bar]')?.querySelector('[data-like-count]')
      );
    }

    function setLiked(btn, liked) {
      if (liked) btn.dataset.liked = 'true';
      else delete btn.dataset.liked;
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    }

    function setCount(btn, count) {
      const countEl = likeCountEl(btn);
      if (!countEl || typeof count !== 'number' || !Number.isFinite(count)) return;
      const n = Math.max(0, count);
      countEl.textContent = String(n);
      const wrap = countEl.closest('[data-like-count-wrap]');
      if (wrap) wrap.hidden = n === 0;
    }

    function adjustCount(btn, delta) {
      const countEl = likeCountEl(btn);
      if (!countEl) return;
      const current = parseInt(countEl.textContent || '0', 10);
      const base = Number.isFinite(current) ? current : 0;
      setCount(btn, Math.max(0, base + delta));
    }

    function reactionCountFrom(activity) {
      const n = activity?.reaction_count ?? activity?.reactionCount;
      return typeof n === 'number' && Number.isFinite(n) ? n : null;
    }

    async function likeRequest(client, activityId, unlike) {
      let response;

      if (unlike) {
        response = await client.deleteActivityReaction({
          activity_id: activityId,
          type: 'like',
        });
      } else {
        response = await client.addActivityReaction({
          activity_id: activityId,
          type: 'like',
          enforce_unique: true,
        });
      }

      return {
        reactionCount: reactionCountFrom(response?.activity),
      };
    }

    async function toggleLike(btn) {
      const root = engageRoot(btn);
      if (!canEngage(root)) {
        if (shouldPromptAuth(root)) loginRedirect();
        return;
      }

      const activityId = activityIdFor(btn);
      if (!activityId || activityId === 'x') return;

      if (btn.dataset.liking === 'true') return;
      btn.dataset.liking = 'true';

      const wasLiked = 'liked' in btn.dataset;
      setLiked(btn, !wasLiked);
      adjustCount(btn, wasLiked ? -1 : 1);

      try {
        const client = await getClient(root);
        if (!client) {
          if (shouldPromptAuth(root)) loginRedirect();
          return;
        }

        const result = await likeRequest(client, activityId, wasLiked);
        if (result.reactionCount != null) {
          setCount(btn, result.reactionCount);
        }
        hydratedIds.add(activityId);
      } catch (err) {
        setLiked(btn, wasLiked);
        adjustCount(btn, wasLiked ? 1 : -1);
        console.error('[community-engage] like failed', err);
      } finally {
        delete btn.dataset.liking;
      }
    }

    function reactionActivityId(reaction) {
      return reaction?.activity_id || reaction?.activityId || '';
    }

    /**
     * Own-like state via batchQueryActivityReactions; counts via one
     * queryActivities for the same ids (batch reactions has no counts;
     * queryActivities has no own_reactions). Two calls beats N× getActivity.
     *
     * Like buttons are collected page-wide: related-project cards can sit
     * outside [data-community-engage] when the browser auto-closes the
     * section early. Credentials still come from `root`.
     */
    async function hydrateLikes(root) {
      const buttons = likeButtons(document);
      const skip = hydrateSkipReason(root);

      if (skip) {
        logDebug('hydrate skipped:', skip);
        return;
      }
      if (!canEngage(root)) return;

      if (!buttons.length) {
        logDebug('hydrate: no like buttons on page');
        return;
      }

      const byId = new Map();
      for (const btn of buttons) {
        const id = activityIdFor(btn);
        if (!byId.has(id)) byId.set(id, []);
        byId.get(id).push(btn);
      }

      const ids = [...byId.keys()].filter((id) => !hydratedIds.has(id));
      if (!ids.length) return;

      try {
        const client = await getClient(root);
        if (!client) {
          console.error('[community-engage] hydrate skipped: connectUser client unavailable');
          return;
        }

        if (typeof client.batchQueryActivityReactions !== 'function') {
          console.error('[community-engage] batchQueryActivityReactions unavailable on client');
          return;
        }

        const likedIds = new Set();
        const countsById = new Map();
        const chunkSize = 100;

        for (let i = 0; i < ids.length; i += chunkSize) {
          const chunk = ids.slice(i, i + chunkSize);

          const [reactionsData, activitiesData] = await Promise.all([
            client.batchQueryActivityReactions({
              activity_ids: chunk,
              filter: { reaction_type: 'like' },
            }),
            client.queryActivities({
              filter: { id: { $in: chunk } },
              limit: Math.min(100, chunk.length),
            }),
          ]);

          for (const reaction of reactionsData?.reactions || []) {
            const activityId = reactionActivityId(reaction);
            if (activityId) likedIds.add(activityId);
          }

          for (const activity of activitiesData?.activities || []) {
            const id = activity?.id;
            if (!id) continue;
            const count = reactionCountFrom(activity);
            if (count != null) countsById.set(id, count);
          }
        }

        for (const id of ids) {
          hydratedIds.add(id);
          const liked = likedIds.has(id);
          const count = countsById.get(id);
          for (const btn of byId.get(id) || []) {
            setLiked(btn, liked);
            if (count != null) setCount(btn, count);
          }
        }

        logDebug(`hydrate done: ${likedIds.size}/${ids.length} liked`, ids);
      } catch (err) {
        console.error('[community-engage] hydrate failed', err);
      }
    }

    function scheduleHydrate(root) {
      clearTimeout(hydrateTimer);
      hydrateTimer = setTimeout(() => hydrateLikes(root), 50);
    }

    function followButtons() {
      return [...document.querySelectorAll('[data-action="follow"]')];
    }

    function setFollowing(following) {
      for (const btn of followButtons()) {
        const wasFollowing = 'following' in btn.dataset;
        if (wasFollowing === following) continue;
        if (following) btn.dataset.following = 'true';
        else delete btn.dataset.following;
        btn.setAttribute('aria-pressed', following ? 'true' : 'false');
        const label = btn.querySelector('.maker-profile-hero__follow-label');
        if (!label) continue;
        label.textContent = following
          ? (btn.dataset.labelFollowing || 'Following')
          : (btn.dataset.labelFollow || 'Follow');
      }
    }

    function adjustFollowerCount(delta) {
      const counts = document.querySelectorAll('[data-stat="followers"]');
      counts.forEach((el) => {
        const current = parseInt(el.textContent || '0', 10);
        const base = Number.isFinite(current) ? current : 0;
        el.textContent = String(Math.max(0, base + delta));
      });
    }

    function followEdge(root) {
      const viewerId = root?.dataset.streamUserId || '';
      const targetId = root?.dataset.userId || '';
      if (!viewerId || !targetId || viewerId === targetId) return null;
      return {
        source: `user:${viewerId}`,
        target: `user:${targetId}`,
      };
    }

    async function toggleFollow(btn) {
      const root = engageRoot(btn);
      if (!canEngage(root)) {
        if (shouldPromptAuth(root)) loginRedirect();
        return;
      }

      const edge = followEdge(root);
      if (!edge || followBusy) return;

      followBusy = true;
      const buttons = followButtons();
      buttons.forEach((b) => { b.dataset.followingBusy = 'true'; });

      const wasFollowing = 'following' in btn.dataset;
      setFollowing(!wasFollowing);
      adjustFollowerCount(wasFollowing ? -1 : 1);

      try {
        const client = await getClient(root);
        if (!client) {
          setFollowing(wasFollowing);
          adjustFollowerCount(wasFollowing ? 1 : -1);
          if (shouldPromptAuth(root)) loginRedirect();
          return;
        }

        if (wasFollowing) await client.unfollow(edge);
        else await client.follow(edge);
      } catch (err) {
        setFollowing(wasFollowing);
        adjustFollowerCount(wasFollowing ? 1 : -1);
        console.error('[community-engage] follow failed', err);
      } finally {
        followBusy = false;
        buttons.forEach((b) => { delete b.dataset.followingBusy; });
      }
    }

    function commentUrlFor(btn) {
      return btn.dataset.commentUrl || '';
    }

    function openComments(btn) {
      const commentUrl = commentUrlFor(btn);
      if (!commentUrl) return;

      const root = engageRoot(btn);
      if (shouldPromptAuth(root)) {
        // return_to must be the project conversation, not the listing page
        try {
          const target = new URL(commentUrl, window.location.origin);
          loginRedirect(target.pathname + target.search + target.hash);
        } catch (_) {
          loginRedirect(commentUrl);
        }
        return;
      }

      window.location.href = commentUrl;
    }

    document.addEventListener('click', (event) => {
      const actionEl = event.target.closest('[data-action]');
      if (!actionEl) return;
      const action = actionEl.dataset.action;

      // Strict equality so comment-like / comment-reply never match "comment" or "like"
      if (action === 'comment') {
        event.preventDefault();
        openComments(actionEl);
        return;
      }

      if (action === 'like') {
        event.preventDefault();
        toggleLike(actionEl);
        return;
      }

      if (action === 'follow') {
        event.preventDefault();
        toggleFollow(actionEl);
      }
    });

    function boot() {
      const root = document.querySelector('[data-community-engage]');
      syncFlagAttrs(root);
      if (root) hydrateLikes(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          const root = document.querySelector('[data-community-engage]');
          if (!root) continue;
          const hasLike = node.matches?.('[data-action="like"]') || node.querySelector?.('[data-action="like"]');
          if (hasLike) scheduleHydrate(root);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["library-card"] && !Shopify.designMode) return;
  try {
    // Helper function to update UI after successful API call
    const updatePatternVisibility = (item, isHidden) => {
        item.setAttribute('data-item-hidden', isHidden ? 'true' : 'false');
        
        // Update all visibility icons (both library and api routes)
        const hidePatternIcons = item.querySelectorAll('.hide-pattern-icon');
        const showPatternIcons = item.querySelectorAll('.show-pattern-icon');
        const hiddenPatternTag = item.querySelector('.hidden-pattern-tag');
        const image = item.querySelector('.image');

        hidePatternIcons.forEach(icon => {
            if (isHidden) {
                icon.classList.add('hidden');
            } else {
                icon.classList.remove('hidden');
            }
        });

        showPatternIcons.forEach(icon => {
            if (isHidden) {
                icon.classList.remove('hidden');
            } else {
                icon.classList.add('hidden');
            }
        });

        if (hiddenPatternTag) {
            if (isHidden) {
                hiddenPatternTag.classList.remove('hidden');
            } else {
                hiddenPatternTag.classList.add('hidden');
            }
        }

        if (image) {
            if (isHidden) {
                image.classList.add('opacity-50');
            } else {
                image.classList.remove('opacity-50');
            }
        }
    };

    const toggleHiddenPattern = (item, customer_id) => {
        const product_id = item.getAttribute('data-product-id');

        const isHidden = item.getAttribute('data-item-hidden') === 'true';

        const libraryContainer = document.querySelector('.library-items');
        const token = libraryContainer?.getAttribute('data-auth-token') || '';

        const itemId = item.getAttribute('data-item-id');
        const newHiddenState = !isHidden;

        // Make API call
        let apiCall;

        apiCall = fetch(`/a/library/api/v1/users/${customer_id}/products/${product_id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sku: itemId,
                action: newHiddenState ? 'hide' : 'show',
                auth_token: token
            })
        });

        apiCall
            .then(response => {
                if (response.ok) {
                    updatePatternVisibility(item, newHiddenState);
                    item.querySelector('[data-library-toggle]:not(.hidden)')?.focus();
                } else {
                    console.error(`Error ${newHiddenState ? 'hiding' : 'showing'} pattern:`, response.error || 'Unknown error');
                }
            })
            .catch(error => {
                console.error(`Error ${newHiddenState ? 'hiding' : 'showing'} pattern:`, error);
            });
    };

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-library-toggle]');
        if (!button) return;
        const item = button.closest('.library-card');
        if (item) toggleHiddenPattern(item, button.getAttribute('data-customer-id'));
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.prod_addToCart').forEach(function(button) {
        button.addEventListener('click', function() {

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: button.getAttribute('data-variant-id'),
                    quantity: parseInt(button.getAttribute('data-qty'), 10)
                })
            })
            .then(response => updateHeaderCartLink())
            .catch(error => console.error('Error adding to cart:', error));
        });
    });

    function updateHeaderCartLink() {
        fetch('/?section_id=header-cart-link')
            .then(response => response.text())
            .then(html => {
                const currentCart = document.querySelector('#header-cart-link');
                if (currentCart) {
                    currentCart.innerHTML = html;
                }
            });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["seo-text-hp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        var readMoreLink = document.querySelector('.readMore_link');
        if (readMoreLink) {
            readMoreLink.addEventListener('click', function(event) {
                event.preventDefault();
                var hiddenPs = Array.from(this.parentElement.querySelectorAll('.metafield-rich_text_field p:nth-of-type(n+4)'));
                if (this.dataset.expanded === 'true') {
                    hiddenPs.forEach(function(p){ p.classList.remove('expanded'); });
                    this.querySelector('.readMore_label').textContent = this.dataset.readMore;
                    this.querySelector('.readMore_icon').classList.remove('rotate-180');
                    this.dataset.expanded = 'false';
                } else {
                    hiddenPs.forEach(function(p){ p.classList.add('expanded'); });
                    this.querySelector('.readMore_label').textContent = this.dataset.readLess;
                    this.querySelector('.readMore_icon').classList.add('rotate-180');
                    this.dataset.expanded = 'true';
                }
            });
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["standard-carousel"] && !Shopify.designMode) return;
  try {
    const XXS_MOBILE_BREAKPOINT = 340;
  const XS_MOBILE_BREAKPOINT = 480;
  const MOBILE_BREAKPOINT = 640;
  const DEBOUNCE_DELAY = 200;
  const AUTO_ROTATE_INTERVAL = 12000;
  const FADE_DURATION_MS = 700;
  const FADE_SWAP_DELAY_MS = 150;
  const SLOW_FADE_DURATION_MS = 1200;
  const SLOW_FADE_SWAP_DELAY_MS = 600;

  const calculateCurrentPage = (index, itemsPerView) => {
    return Math.floor(index / itemsPerView);
  };
  
  const calculateMaxPage = (maxIndex, itemsPerView) => {
    return Math.floor(maxIndex / itemsPerView);
  };
  
  const calculateNumDots = (itemsPerView, totalItems) => {
    return itemsPerView === 1 ? totalItems : Math.ceil(totalItems / itemsPerView);
  };
  
  const createDot = (index) => {
    const dot = document.createElement('button');
    dot.className = 'carousel-dot';
    dot.setAttribute('data-index', index);
    dot.setAttribute('aria-label', `Go to page ${index + 1}`);
    return dot;
  };
  
  const getItemsPerView = (itemsPerView, totalItems) => {
    if (itemsPerView > 1) {
      return window.innerWidth < XXS_MOBILE_BREAKPOINT ? 1 : window.innerWidth < XS_MOBILE_BREAKPOINT ? Math.min(2, totalItems) : window.innerWidth < MOBILE_BREAKPOINT ? Math.min(3, totalItems) : itemsPerView;
    }
    return itemsPerView;
  };
  
  const getMaxIndex = (totalItems) => {
    return Math.max(0, totalItems - 1);
  };
  
  const updateItemWidths = (items, currentItemsPerView) => {
    const itemWidth = 100 / currentItemsPerView;
    items.forEach(item => {
      item.style.width = `${itemWidth}%`;
      item.style.minWidth = `${itemWidth}%`;
    });
  };
  
  const updatePosition = (track, currentIndex, currentItemsPerView, withFade = false, slowFade = false) => {
    const itemWidth = 100 / currentItemsPerView;
    const translateX = -(currentIndex * itemWidth);
    
    if (withFade) {
      // Fade out, change position, fade in - to handle infinite navigation gracefully
      const duration = slowFade ? SLOW_FADE_DURATION_MS : FADE_DURATION_MS;
      const swapDelay = slowFade ? SLOW_FADE_SWAP_DELAY_MS : FADE_SWAP_DELAY_MS;
      const fadeTransition = `opacity ${duration}ms ease-in-out`;
      track.style.transition = fadeTransition;
      track.style.opacity = '0';

      setTimeout(() => {
        track.style.transition = fadeTransition;
        track.style.transform = `translateX(${translateX}%)`;

        requestAnimationFrame(() => {
          track.style.opacity = '1';
        });
      }, swapDelay);
    } else {
      // Instant position change with no animation
      track.style.transition = 'none';
      track.style.transform = `translateX(${translateX}%)`;
      // Reset transition after applying transform
      requestAnimationFrame(() => {
        track.style.transition = '';
      });
    }
  };
  
  const needsNavigation = (currentItemsPerView, totalItems) => {
    return totalItems > currentItemsPerView;
  };
  
  const updateButtonStates = (prevBtn, nextBtn, currentIndex, currentItemsPerView, totalItems) => {
    if (!prevBtn || !nextBtn) return;
    
    const shouldShowButtons = needsNavigation(currentItemsPerView, totalItems);
    
    if (shouldShowButtons) {
      // Show buttons and enable infinite navigation
      prevBtn.classList.remove('hidden');
      nextBtn.classList.remove('hidden');
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      
      prevBtn.classList.add('text-active');
      prevBtn.classList.remove('text-medium');
      nextBtn.classList.add('text-active');
      nextBtn.classList.remove('text-medium');
    } else {
      // Hide buttons when all items fit on one page
      prevBtn.classList.add('hidden');
      nextBtn.classList.add('hidden');
    }
  };
  
  const generateDots = (positionIndicator, itemsPerView, numDots) => {
    if (!positionIndicator) return;

    positionIndicator.innerHTML = '';

    for (let i = 0; i < numDots; i++) {
      const dot = createDot(i);
      positionIndicator.appendChild(dot);
    }
  };
  
  const updatePositionIndicator = (positionIndicator, currentItemsPerView, totalItems, showDotsEnabled) => {
    if (!positionIndicator) return;
    
    const numDots = calculateNumDots(currentItemsPerView, totalItems);
    const numDotsInRange = numDots > 1 && numDots < 11;
    const shouldShowDots = numDotsInRange && (currentItemsPerView === 1 || showDotsEnabled);

    if (shouldShowDots) {
      positionIndicator.parentElement.classList.remove('hidden');
      generateDots(positionIndicator, currentItemsPerView, numDots);
    } else {
      positionIndicator.parentElement.classList.add('hidden');
    }
  };
  
  const calculateActiveDotIndex = (currentIndex, currentItemsPerView) => {
    return currentItemsPerView === 1 
      ? currentIndex 
      : calculateCurrentPage(currentIndex, currentItemsPerView);
  };
  
  const updateDots = (positionIndicator, currentIndex, currentItemsPerView) => {
    if (!positionIndicator) return;
    
    const dots = positionIndicator.querySelectorAll('.carousel-dot');
    const activeDotIndex = calculateActiveDotIndex(currentIndex, currentItemsPerView);
    
    dots.forEach((dot, index) => {
      const isActive = index === activeDotIndex;
      
      if (isActive) {
        dot.classList.remove('dot-inactive');
        dot.classList.add('dot-active');
      } else {
        dot.classList.remove('dot-active');
        dot.classList.add('dot-inactive');
      }
    });
  };
  
  const positionArrows = (carousel) => {
    const firstImage = carousel.querySelector('img');
    const prevBtn = carousel.querySelector('.carousel-prev');
    const nextBtn = carousel.querySelector('.carousel-next');
    
    if (firstImage && prevBtn && nextBtn) {
      const imageHeight = firstImage.offsetHeight;
      const imageTop = firstImage.offsetTop;
      const arrowPosition = imageTop + (imageHeight / 2);
      
      prevBtn.style.top = `${arrowPosition}px`;
      nextBtn.style.top = `${arrowPosition}px`;
      prevBtn.style.transform = 'translateY(-50%)';
      nextBtn.style.transform = 'translateY(-50%)';
    }
  };

  const updateCarousel = (carouselState, withFade = false, slowFade = false) => {
    const { itemsPerView, items, track, currentIndex, totalItems, prevBtn, nextBtn, positionIndicator, showDotsEnabled, carousel } = carouselState;
    const currentItemsPerView = getItemsPerView(itemsPerView, totalItems);
    
    updateItemWidths(items, currentItemsPerView);
    updatePosition(track, currentIndex, currentItemsPerView, withFade, slowFade);
    updateButtonStates(prevBtn, nextBtn, currentIndex, currentItemsPerView, totalItems);
    updatePositionIndicator(positionIndicator, currentItemsPerView, totalItems, showDotsEnabled);
    updateDots(positionIndicator, currentIndex, currentItemsPerView);
    positionArrows(carousel);
  };
  
  const navigateToPrevious = (carouselState) => {
    const { itemsPerView, currentIndex, totalItems } = carouselState;
    const currentItemsPerView = getItemsPerView(itemsPerView, totalItems);
    
    if (currentItemsPerView === 1) {
      // Mobile: move one item at a time 
      const maxIndex = getMaxIndex(totalItems);
      if (currentIndex > 0) {
        carouselState.currentIndex--;
      } else {
        // Wrap to last item
        carouselState.currentIndex = maxIndex;
      }
      updateCarousel(carouselState, true);
    } else {
      // Desktop: move one page at a time
      const maxIndex = getMaxIndex(totalItems);
      const currentPage = calculateCurrentPage(currentIndex, currentItemsPerView);
      const maxPage = calculateMaxPage(maxIndex, currentItemsPerView);
      
      if (currentPage > 0) {
        carouselState.currentIndex = (currentPage - 1) * currentItemsPerView;
      } else {
        // Wrap to last page
        carouselState.currentIndex = maxPage * currentItemsPerView;
      }
      updateCarousel(carouselState, true);
    }
  };
  
  const navigateToNext = (carouselState, slowFade = false) => {
    const { itemsPerView, currentIndex, totalItems } = carouselState;
    const currentItemsPerView = getItemsPerView(itemsPerView, totalItems);
    
    if (currentItemsPerView === 1) {
      // Mobile: move one item at a time
      const maxIndex = getMaxIndex(totalItems);
      if (currentIndex < maxIndex) {
        carouselState.currentIndex++;
      } else {
        // Flip back to first item
        carouselState.currentIndex = 0;
      }
      updateCarousel(carouselState, true, slowFade);
    } else {
      // Desktop: move one page at a time
      const maxIndex = getMaxIndex(totalItems);
      const currentPage = calculateCurrentPage(currentIndex, currentItemsPerView);
      const maxPage = calculateMaxPage(maxIndex, currentItemsPerView);
      
      if (currentPage < maxPage) {
        carouselState.currentIndex = (currentPage + 1) * currentItemsPerView;
      } else {
        // Flip back to first page
        carouselState.currentIndex = 0;
      }
      updateCarousel(carouselState, true, slowFade);
    }
  };
  
  const navigateToPage = (carouselState, targetPage) => {
    const { itemsPerView, totalItems } = carouselState;
    const currentItemsPerView = getItemsPerView(itemsPerView, totalItems);
    
    if (currentItemsPerView === 1) {
      // Mobile: go to specific item
      carouselState.currentIndex = targetPage;
    } else {
      // Desktop: go to specific page
      carouselState.currentIndex = targetPage * currentItemsPerView;
    }
    updateCarousel(carouselState, true);
  };
  
  const createResizeObserver = (carouselState) => {
    let resizeTimeout = null;
    
    const resizeObserver = new ResizeObserver((entries) => {
      // Only update if the carousel container actually changed size
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateCarousel(carouselState);
      }, DEBOUNCE_DELAY);
    });
    
    return resizeObserver;
  };

  const startAutoRotate = (carouselState) => {
    if (!carouselState.autoRotateEnabled) return;
    stopAutoRotate(carouselState);
    carouselState.autoRotateTimer = setInterval(() => {
      navigateToNext(carouselState, true);
    }, AUTO_ROTATE_INTERVAL);
  };

  const stopAutoRotate = (carouselState) => {
    if (carouselState.autoRotateTimer) {
      clearInterval(carouselState.autoRotateTimer);
      carouselState.autoRotateTimer = null;
    }
  };

  // Restart the timer after manual interaction
  const resetAutoRotate = (carouselState) => {
    if (!carouselState.autoRotateEnabled) return;
    startAutoRotate(carouselState);
  };

  const addAutoRotate = (carouselState) => {
    const { carousel } = carouselState;
    if (!carouselState.autoRotateEnabled) return;

    carousel.addEventListener('mouseenter', () => stopAutoRotate(carouselState));
    carousel.addEventListener('mouseleave', () => startAutoRotate(carouselState));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoRotate(carouselState);
      } else {
        startAutoRotate(carouselState);
      }
    });

    startAutoRotate(carouselState);
  };

  const addTouchSupport = (carouselState) => {
    const { track, carousel } = carouselState;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let startTime = 0;
    
    // Min horizontal distance for a swipe to be considered valid
    const MIN_SWIPE_DISTANCE = 50;
    // Max vertical distance to still be considered a horizontal swipe
    const MAX_VERTICAL_DISTANCE = 100;
    // Max time for a swipe gesture to be considered valid
    const MAX_SWIPE_TIME = 500;
    
    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      startTime = Date.now();
    };
    
    const handleTouchEnd = (event) => {
      const touch = event.changedTouches[0];
      touchEndX = touch.clientX;
      touchEndY = touch.clientY;
      
      const deltaX = touchEndX - touchStartX;
      const deltaY = Math.abs(touchEndY - touchStartY);
      const deltaTime = Date.now() - startTime;
      
      const isValidSwipe = Math.abs(deltaX) >= MIN_SWIPE_DISTANCE && 
                         deltaY <= MAX_VERTICAL_DISTANCE && 
                         deltaTime <= MAX_SWIPE_TIME;
      
      if (isValidSwipe) {
        if (deltaX > 0) {
          navigateToPrevious(carouselState);
        } else {
          navigateToNext(carouselState);
        }
        resetAutoRotate(carouselState);
      }
    };

    track.addEventListener('touchstart', handleTouchStart);
    track.addEventListener('touchend', handleTouchEnd);
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.carousel');
    
    carousels.forEach(carousel => {
      const carouselId = carousel.id;
      if (!carouselId) return;
      
      const track = carousel.querySelector('.carousel-track');
      const items = carousel.querySelectorAll('.carousel-item');
      const prevBtn = carousel.querySelector('.carousel-prev');
      const nextBtn = carousel.querySelector('.carousel-next');
      const positionIndicator = carousel.querySelector('.carousel-position-indicator');
      
      if (!track || !items.length) return;
      
      const itemsPerView = parseInt(carousel.dataset.itemsPerView) || 4;
      const showDotsEnabled = carousel.dataset.showDots === 'true';
      const autoRotateEnabled = carousel.dataset.autoRotate === 'true'
        && needsNavigation(getItemsPerView(itemsPerView, items.length), items.length);
      
      const carouselState = {
        currentIndex: 0,
        totalItems: items.length,
        itemsPerView,
        showDotsEnabled,
        autoRotateEnabled,
        autoRotateTimer: null,
        carousel,
        track,
        items,
        prevBtn,
        nextBtn,
        positionIndicator
      };
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          navigateToPrevious(carouselState);
          resetAutoRotate(carouselState);
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          navigateToNext(carouselState);
          resetAutoRotate(carouselState);
        });
      }
      
      if (positionIndicator) {
        positionIndicator.addEventListener('click', (event) => {
          const dot = event.target.closest('.carousel-dot');
          if (dot) {
            const targetPage = parseInt(dot.getAttribute('data-index'), 10);
            if (!isNaN(targetPage)) {
              navigateToPage(carouselState, targetPage);
              resetAutoRotate(carouselState);
            }
          }
        });
      }
    
      const resizeObserver = createResizeObserver(carouselState);
      resizeObserver.observe(carousel);
    
      addTouchSupport(carouselState);
      addAutoRotate(carouselState);

      updateCarousel(carouselState);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tooltip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll('.tooltip');
  
  tooltips.forEach(tooltip => {
    const tooltipContent = tooltip.querySelector('.tooltip-content');
    let isVisible = false;
    
    const showTooltip = () => {
      tooltipContent.classList.remove('invisible');
      tooltipContent.classList.add('visible');
      isVisible = true;
    };
    
    const hideTooltip = () => {
      tooltipContent.classList.remove('visible');
      tooltipContent.classList.add('invisible');
      isVisible = false;
    };
    
    tooltip.addEventListener('click', (e) => {
      e.preventDefault();
      if (isVisible) {
        hideTooltip();
      } else {
        showTooltip();
      }
    });
    
    // Hide when clicking outside of the tooltip
    document.addEventListener('click', (e) => {
      if (!tooltip.contains(e.target) && isVisible) {
        hideTooltip();
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-init"] && !Shopify.designMode) return;
  try {
    if (!window.__wishlistInitTriggered) {
    window.__wishlistInitTriggered = true;

    const postWishlistRequest = ({variantIds, productIds, action, entryId}) => {
        if (!action || !['add', 'delete', 'query'].includes(action)) {
            throw new Error('Action is required and must be one of: add, delete, query');
        }
        let body = {};
        let apiEndpoint = null;

        if (action === 'add') {
            apiEndpoint = `/a/wishlists/api/favorites`;
            const variantId = Array.isArray(variantIds) && variantIds.length > 0 ? variantIds[0] : null;
            const productId = Array.isArray(productIds) && productIds.length > 0 ? productIds[0] : null;
            if (variantId) {
                body.variant_id = variantId;
            } 
            if (productId) {
                body.product_id = productId;
            } 
            if (!variantId && !productId) {
                throw new Error('Either variantId or productId is required');
            }
        } else if (action === 'delete') {
            if (!entryId) {
                throw new Error('Entry ID is required for delete action');
            }
            apiEndpoint = `/a/wishlists/api/favorites/${entryId}?_method=DELETE`;
        } else if (action === 'query') {
            let productIdsString = '';
            let variantIdsString = '';
            if (Array.isArray(variantIds) && variantIds.length > 0) {
                variantIdsString = variantIds.join(',');
            }
            if (Array.isArray(productIds) && productIds.length > 0) {
                productIdsString = productIds.join(',');
            }
            if (!productIdsString && !variantIdsString) {
                throw new Error('No SKU strings provided');
            }

            const params = new URLSearchParams({
                productIds: productIdsString,
                variantIds: variantIdsString,
            }).toString();
            apiEndpoint = `/a/wishlists/api/favorites/query?${params}`;
        }

        return fetch(apiEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(async (response) => {
            const text = await response.text();
            if (!response.ok) {
                throw new Error(`Error calling wishlist API for action "${action}": ${response.status}`);
            }
            try {
                return JSON.parse(text);
            } catch (e) {
                throw new Error(`Wishlist API returned non-JSON (status 200). Check app is installed and endpoint returns JSON.`);
            }
        });
    };

    const getVariantId = (el) => el.getAttribute('data-variant-id');
    const getProductId = (el) => el.getAttribute('data-product-id');

    const setIconTitle = (el, text) => {
        const title = el.querySelector('title');
        if (title) title.textContent = text;
    };

    const setWishlistPcardUI = (element, inWishlist, entryId) => {
        if (entryId) element.setAttribute('data-wishlist-entry-id', entryId);
        element.classList.toggle('is-active', inWishlist);
        element.setAttribute('data-in-wishlist', inWishlist);
        const newLabel = inWishlist
            ? element.getAttribute('data-remove-from-wishlist')
            : element.getAttribute('data-add-to-wishlist');
        if (newLabel) setIconTitle(element, newLabel);
    };

    const setWishlistPdpElementUI = (element, inWishlist, entryId) => {
        if (entryId) element.setAttribute('data-wishlist-entry-id', entryId);
        element.classList.toggle('is-active-pdp', inWishlist);
        element.setAttribute('data-in-wishlist', inWishlist);
        const newLabel = inWishlist
            ? element.getAttribute('data-remove-from-wishlist')
            : element.getAttribute('data-add-to-wishlist');
        if (newLabel) setIconTitle(element, newLabel);
        const label = element.querySelector('.wishlist-label');
        if (label) label.textContent = newLabel;
    };

    const setWishlistPdpUI = ({ variantId, productId, inWishlist, entryId }) => {
        const isVariant = !!variantId;
        document.querySelectorAll('.wishlist_pdp').forEach((el) => {
            if (isVariant && getVariantId(el) !== variantId) return;
            if (!isVariant && getProductId(el) !== productId) return;
            setWishlistPdpElementUI(el, inWishlist, entryId);
        });
    };

    const checkIsCustomerLoggedIn = () => {
        if (!window.isLoggedIn) {
            const { pathname, search, hash } = document.location;
            window.location.href = '/customer_authentication/login?return_to=' + pathname + search + hash;
            return;
        }
    };

    const isForceInWishlist = (value) => value === true || value === false;

    const getWishlistIds = (element) => ({
        productId: getProductId(element),
        variantId: getVariantId(element),
    });

    const getEntryId = (providedEntryId, element) => {
        const raw = providedEntryId ?? element.getAttribute('data-wishlist-entry-id');
        return raw ? raw : null;
    };

    const getIsAdding = (element) => element.getAttribute('data-in-wishlist') !== 'true';

    const buildToggleRequest = ({ isVariant, productId, variantId, isAdding, entryId }) => {
        const payload = {
            action: isAdding ? 'add' : 'delete',
        };

        if (entryId) payload.entryId = entryId;

        if (isVariant) {
            payload.variantIds = [variantId];
        } else {
            payload.productIds = [productId];
        }

        return payload;
    };

    const toggleWishlistPcard = (element, forceInWishlist, entryId) => {
        const { productId, variantId } = getWishlistIds(element);
        if (!productId && !variantId) return;
        const isVariant = !!variantId;

        // If forceInWishlist is provided, it's just to set the UI state.
        if (isForceInWishlist(forceInWishlist)) {
            setWishlistPcardUI(element, forceInWishlist, entryId);
            return;
        }

        const isAdding = getIsAdding(element);
        const dataEntryId = getEntryId(entryId, element);
        const data = buildToggleRequest({
            isVariant,
            productId,
            variantId,
            isAdding,
            entryId: dataEntryId,
        });

        postWishlistRequest(data)
            .then((response) => {
                const entryId = isAdding ? response?.id : null;
                setWishlistPcardUI(element, isAdding, entryId)
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const toggleWishlistPdp = (element, forceInWishlist, entryId) => {
        const { productId, variantId } = getWishlistIds(element);
        if (!productId && !variantId) return;
        const isVariant = !!variantId;

        // If forceInWishlist is provided, it's just to set the UI state.
        if (isForceInWishlist(forceInWishlist)) {
            setWishlistPdpElementUI(element, forceInWishlist, entryId);
            return;
        }

        const isAdding = getIsAdding(element);
        const dataEntryId = getEntryId(entryId, element);
        const data = buildToggleRequest({
            isVariant,
            productId,
            variantId,
            isAdding,
            entryId: dataEntryId,
        });

        postWishlistRequest(data)
            .then((response) => {
                const entryId = isAdding ? response?.id : null;
                setWishlistPdpUI({ variantId, productId, inWishlist: isAdding, entryId })
            })
            .catch((error) => {
                console.error('Wishlist request failed:', error.message || error);
            });
    };

    document.addEventListener('click', (e) => {
        const el = e.target.closest('.wishlist_pcard') || e.target.closest('.wishlist_pdp');
        if (!el) return;

        checkIsCustomerLoggedIn();
        
        e.preventDefault();
        e.stopPropagation();
        if (el.classList.contains('wishlist_pcard')) {
            toggleWishlistPcard(el);
        } else {
            toggleWishlistPdp(el);
        }
    });

    // Collects wishlist IDs from the DOM, checks which are active via an API request and toggles the wishlist buttons accordingly.
    const initWishlist = () => {
        if (!window.isLoggedIn) {
            return;
        }

        const collectIds = (selector, attr) =>
            Array.from(document.querySelectorAll(selector)).reduce((acc, el) => {
                const id = el.getAttribute(attr);
                if (id) acc.add(id);
                return acc;
            }, new Set());

        const wishlistProductIds = collectIds('.wishlist_pcard', 'data-product-id');
        const wishlistPdpProductIds = collectIds('.wishlist_pdp', 'data-product-id');
        const wishlistVariantIds = collectIds('.wishlist_pdp', 'data-variant-id');

        const allProductIds = new Set([...wishlistProductIds, ...wishlistPdpProductIds]);
        if (!allProductIds.size && !wishlistVariantIds.size) return;

        postWishlistRequest({
            productIds: Array.from(allProductIds),
            variantIds: Array.from(wishlistVariantIds),
            action: 'query'
        })
            .then((data) => {
                const activeProductIds = data.matchingProductIds || {};
                const activeVariantIds = data.matchingVariantIds || {};

                const applyActiveProduct = (productId, entryId) => {
                    document.querySelectorAll(`.wishlist_pcard[data-product-id="${productId}"]`)
                        .forEach((card) => toggleWishlistPcard(card, true, entryId));

                    document.querySelectorAll(`.wishlist_pdp[data-product-id="${productId}"]`)
                        .forEach((pdp) => toggleWishlistPdp(pdp, true, entryId));
                };

                const applyActiveVariant = (variantId, entryId) => {
                    document.querySelectorAll(`.wishlist_pdp[data-variant-id="${variantId}"]`)
                        .forEach((pdp) => toggleWishlistPdp(pdp, true, entryId));
                };

                Object.entries(activeProductIds).forEach(([productId, entryId]) => {
                    applyActiveProduct(productId, entryId);
                });

                Object.entries(activeVariantIds).forEach(([variantId, entryId]) => {
                    applyActiveVariant(variantId, entryId);
                });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    window.initWishlist = initWishlist;
    document.addEventListener('DOMContentLoaded', initWishlist);
}
  } catch(e) { console.error(e); }
})();

})();
